/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as modelV1 from "./keyapis_device_model_v1.pb"

/**
 * Сервис реализует функционал управления устройствами
 */

/**
 * Сервис устройств
 */
export class DeviceServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получаения устройства.
   * Метод доступен для: admin, service, owner, employee, bti, ltp_first
   */
  GetDevice = (req: GetDeviceRequestDto, init?: RequestInit): Promise<GetDeviceResponseDto> => {
    return fm.request<GetDeviceRequestDto, GetDeviceResponseDto>(`${this.host}/device/api/v1/device/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка устройств.
   * Метод доступен для: admin, service, owner, employee, bti, ltp_first
   */
  GetDeviceList = (req?: GetDeviceListRequestDto, init?: RequestInit): Promise<GetDeviceListResponseDto[]> => {
    return fm.list<GetDeviceListRequestDto, GetDeviceListResponseDto>(`${this.host}/device/api/v1/device/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества устройств.
   * Метод доступен для: admin, service, owner, employee, bti, ltp_first
   */
  GetDeviceCount = (req?: GetDeviceCountRequestDto, init?: RequestInit): Promise<GetDeviceCountResponseDto> => {
    return fm.request<GetDeviceCountRequestDto, GetDeviceCountResponseDto>(`${this.host}/device/api/v1/device/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод создания устройства.
   * Метод доступен для: admin, bti, service, owner, employee.
   * Для owner, employee доступно создание и редактирование только в КВГ, привязанных к компании пользователя
   */
  PostDevice = (req: PostDeviceRequestDto, init?: RequestInit): Promise<PostDeviceResponseDto> => {
    return fm.request<PostDeviceRequestDto, PostDeviceResponseDto>(`${this.host}/device/api/v1/device`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод изменения устройства.
   * Метод доступен для: admin, bti, service
   * @deprecated
   */
  PutDevice = (req: PutDeviceRequestDto, init?: RequestInit): Promise<PutDeviceResponseDto> => {
    return fm.request<PutDeviceRequestDto, PutDeviceResponseDto>(`${this.host}/device/api/v1/device`, { ...init, method: "PUT", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод установки пресета на устройство.
   * Метод доступен для: admin, service
   */
  PostDeviceInstallPreset = (req: PostDeviceInstallPresetRequestDto, init?: RequestInit): Promise<PostDeviceInstallPresetResponseDto> => {
    return fm.request<PostDeviceInstallPresetRequestDto, PostDeviceInstallPresetResponseDto>(`${this.host}/device/api/v1/device/${encodeURIComponent(req.id)}/install_preset`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод замены устройста.
   * Логика работы метода: https://confluence.rt.ru/pages/viewpage.action?pageId=655256574.
   * Метод доступен для: admin, bti, service
   */
  PostDeviceReplace = (req: PostDeviceReplaceRequestDto, init?: RequestInit): Promise<PostDeviceReplaceResponseDto> => {
    return fm.request<PostDeviceReplaceRequestDto, PostDeviceReplaceResponseDto>(`${this.host}/device/api/v1/device/${encodeURIComponent(req.id)}/replace`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод переконфигурирования устройста.
   * Логика работы метода: https://confluence.rt.ru/pages/viewpage.action?pageId=630337555.
   * Метод доступен для: admin, bti, service
   */
  PostDeviceReconfigure = (req: PostDeviceReconfigureRequestDto, init?: RequestInit): Promise<PostDeviceReconfigureResponseDto> => {
    return fm.request<PostDeviceReconfigureRequestDto, PostDeviceReconfigureResponseDto>(`${this.host}/device/api/v1/device/${encodeURIComponent(req.id)}/reconfigure`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения статусов конфигурации устройства.
   * Метод доступен для: admin, service, bti, ltp_first
   */
  GetDeviceConfigurationStatuses = (req: GetDeviceConfigurationStatusesRequestDto, init?: RequestInit): Promise<GetDeviceConfigurationStatusesResponseDto> => {
    return fm.request<GetDeviceConfigurationStatusesRequestDto, GetDeviceConfigurationStatusesResponseDto>(`${this.host}/device/api/v1/device/${encodeURIComponent(req.id)}/configuration_statuses${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод изменения статуса конфигурации устройства.
   * Метод доступен для: admin, service
   */
  PostDeviceConfigurationStatus = (req: PostDeviceConfigurationStatusRequestDto, init?: RequestInit): Promise<PostDeviceConfigurationStatusResponseDto> => {
    return fm.request<PostDeviceConfigurationStatusRequestDto, PostDeviceConfigurationStatusResponseDto>(`${this.host}/device/api/v1/device/configuration_status`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка конфигураций сгруппированных по устройствам.
   * Метод доступен для: admin, service
   */
  GetDeviceConfigurationStatusGroupedList = (req?: GetDeviceConfigurationStatusGroupedListRequestDto, init?: RequestInit): Promise<GetDeviceConfigurationStatusGroupedListResponseDto[]> => {
    return fm.list<GetDeviceConfigurationStatusGroupedListRequestDto, GetDeviceConfigurationStatusGroupedListResponseDto>(`${this.host}/device/api/v1/device/configuration_status/grouped/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества конфигураций сгруппированных по устройствам.
   * Метод доступен для: admin, service
   */
  GetDeviceConfigurationStatusGroupedCount = (req?: GetDeviceConfigurationStatusGroupedCountRequestDto, init?: RequestInit): Promise<GetDeviceConfigurationStatusGroupedCountResponseDto> => {
    return fm.request<GetDeviceConfigurationStatusGroupedCountRequestDto, GetDeviceConfigurationStatusGroupedCountResponseDto>(`${this.host}/device/api/v1/device/configuration_status/grouped/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления устройства.
   * Метод доступен для: admin, service
   */
  DeleteDevice = (req: DeleteDeviceRequestDto, init?: RequestInit): Promise<DeleteDeviceResponseDto> => {
    return fm.request<DeleteDeviceRequestDto, DeleteDeviceResponseDto>(`${this.host}/device/api/v1/device/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получаения упрощенного устройства.
   * Метод доступен для: admin, service, owner, employee, bti, ltp_first.
   * Метод доступен для: ApiKey
   */
  GetDeviceLite = (req: GetDeviceLiteRequestDto, init?: RequestInit): Promise<GetDeviceLiteResponseDto> => {
    return fm.request<GetDeviceLiteRequestDto, GetDeviceLiteResponseDto>(`${this.host}/device/api/v1/device_lite/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Статус камеры.
 */
export enum CameraStatusStatusType {
  /**
   * Значение не указано
   */
  STATUS_TYPE_UNKNOWN = "STATUS_TYPE_UNKNOWN",
  /**
   * В процессе регистрации
   */
  PROCESSING = "PROCESSING",
  /**
   * Ошибка регистрации
   */
  PROCESSING_ERROR = "PROCESSING_ERROR",
  /**
   * Активна
   */
  ACTIVE = "ACTIVE",
}
/**
 * Статус камеры.
 */
export type CameraStatusStatusTypeResponseEnum = keyof typeof CameraStatusStatusType
/**
 * Статус камеры.
 */
export type CameraStatusStatusTypeRequestEnum = Exclude<CameraStatusStatusTypeResponseEnum, "STATUS_TYPE_UNKNOWN">;

/**
 * Тип доступа пользователя.
 */
export enum DeviceCredentialsUserAccessType {
  /**
   * Значение не указано
   */
  USER_ACCESS_TYPE_UNKNOWN = "USER_ACCESS_TYPE_UNKNOWN",
  /**
   * Доступ к api
   */
  API = "API",
  /**
   * Доступ к web-интерфейсу
   */
  WEB = "WEB",
  /**
   * Доступ к rtsp-потоку
   */
  RTSP = "RTSP",
  /**
   * Полный доступ
   */
  SU = "SU",
}
/**
 * Тип доступа пользователя.
 */
export type DeviceCredentialsUserAccessTypeResponseEnum = keyof typeof DeviceCredentialsUserAccessType
/**
 * Тип доступа пользователя.
 */
export type DeviceCredentialsUserAccessTypeRequestEnum = Exclude<DeviceCredentialsUserAccessTypeResponseEnum, "USER_ACCESS_TYPE_UNKNOWN">;

/**
 * Модель устройства.
 */
export enum DeviceModelType {
  /**
   * Значение не указано
   */
  MODEL_TYPE_UNKNOWN = "MODEL_TYPE_UNKNOWN",
  /**
   * Модель RODOS-8
   */
  RODOS8 = "RODOS8",
  /**
   * Модель Beward
   */
  BEWARD = "BEWARD",
  /**
   * Модель QTECH
   */
  QTECH = "QTECH",
  /**
   * Модель Натекс
   */
  NATEKS = "NATEKS",
  /**
   * Модель ТНБ
   */
  TNB = "TNB",
  /**
   * Модель Maxet Line
   */
  MAXETLINE = "MAXETLINE",
  /**
   * Модель Двойная открывашка
   */
  TNB_DO2 = "TNB_DO2",
  /**
   * Модель Beward DS86017CP
   */
  BEWARD_DS86017CP = "BEWARD_DS86017CP",
  /**
   * Модель Beward DS85006MP
   */
  BEWARD_DS85006MP = "BEWARD_DS85006MP",
  /**
   * Модель Dahua DHI-VTO2101E-P
   */
  DAHUA_VTO2101E_P = "DAHUA_VTO2101E_P",
  /**
   * Модель Hikvision DS-KV8155-IM
   */
  HIKVISION_DS_KV8155_IM = "HIKVISION_DS_KV8155_IM",
  /**
   * Модель RODOS-8-2
   */
  RODOS8_2 = "RODOS8_2",
  /**
   * Модель Akuvox R29C
   */
  AKUVOX_R29C = "AKUVOX_R29C",
  /**
   * Модель Safe-logic
   */
  SAFE_LOGIC = "SAFE_LOGIC",
  /**
   * Модель Beward DS86006AP
   */
  BEWARD_DS86006AP = "BEWARD_DS86006AP",
  /**
   * Модель Спутник Ио
   */
  SPUTNIK_IO = "SPUTNIK_IO",
  /**
   * Модель Beward c FR
   */
  BEWARD_FR = "BEWARD_FR",
  /**
   * Модель QTECH с FR
   */
  QTECH_FR = "QTECH_FR",
  /**
   * Модель Eltex IPA-ER-10
   */
  ELTEX_IPA_ER_010 = "ELTEX_IPA_ER_010",
  /**
   * Модель Beward с новым API ключей
   */
  BEWARD_MIFARE = "BEWARD_MIFARE",
  /**
   * Модель BAS-IP AA-12FB
   */
  BAS_IP_AA_12FB = "BAS_IP_AA_12FB",
  /**
   * Модель Akuvox X915S
   */
  AKUVOX_X915S = "AKUVOX_X915S",
  /**
   * Модель Rubetek RV-3434
   */
  RUBETEK_RV_3434 = "RUBETEK_RV_3434",
  /**
   * Модель Сокол плюс
   */
  SOKOL_PLUS = "SOKOL_PLUS",
  /**
   * Модель Beward Эконом
   */
  BEWARD_LOW_COST = "BEWARD_LOW_COST",
}
/**
 * Модель устройства.
 */
export type DeviceModelTypeResponseEnum = keyof typeof DeviceModelType
/**
 * Модель устройства.
 */
export type DeviceModelTypeRequestEnum = Exclude<DeviceModelTypeResponseEnum, "MODEL_TYPE_UNKNOWN">;

/**
 * Справочник статусов установки пресета.
 * @deprecated
 */
export enum DevicePresetStatusType {
  /**
   * Значение не указано
   * @deprecated
   */
  PRESET_STATUS_TYPE_UNKNOWN = "PRESET_STATUS_TYPE_UNKNOWN",
  /**
   * Устанавливается
   * @deprecated
   */
  PROCESSING = "PROCESSING",
  /**
   * Установлен
   * @deprecated
   */
  SUCCESS = "SUCCESS",
  /**
   * Ошибка
   * @deprecated
   */
  ERROR = "ERROR",
}
/**
 * Справочник статусов установки пресета.
 * @deprecated
 */
export type DevicePresetStatusTypeResponseEnum = keyof typeof DevicePresetStatusType
/**
 * Справочник статусов установки пресета.
 * @deprecated
 */
export type DevicePresetStatusTypeRequestEnum = Exclude<DevicePresetStatusTypeResponseEnum, "PRESET_STATUS_TYPE_UNKNOWN">;

/**
 * Тип сети связи.
 */
export enum DeviceSipTrunkSipType {
  /**
   * Значение не указано
   */
  SIP_TYPE_UNKNOWN = "SIP_TYPE_UNKNOWN",
  /**
   * Тип Viprtual IP Multimedia Subsystem
   */
  VIMS = "VIMS",
  /**
   * Тип Next Generation Networks
   */
  NGN = "NGN",
}
/**
 * Тип сети связи.
 */
export type DeviceSipTrunkSipTypeResponseEnum = keyof typeof DeviceSipTrunkSipType
/**
 * Тип сети связи.
 */
export type DeviceSipTrunkSipTypeRequestEnum = Exclude<DeviceSipTrunkSipTypeResponseEnum, "SIP_TYPE_UNKNOWN">;

/**
 * Справочник статусов устройства.
 */
export enum DeviceStatusType {
  /**
   * Значение не указано
   */
  STATUS_TYPE_UNKNOWN = "STATUS_TYPE_UNKNOWN",
  /**
   * Не в сети
   */
  OFFLINE = "OFFLINE",
  /**
   * В сети
   */
  ONLINE = "ONLINE",
}
/**
 * Справочник статусов устройства.
 */
export type DeviceStatusTypeResponseEnum = keyof typeof DeviceStatusType
/**
 * Справочник статусов устройства.
 */
export type DeviceStatusTypeRequestEnum = Exclude<DeviceStatusTypeResponseEnum, "STATUS_TYPE_UNKNOWN">;

/**
 * Справочник назначений типов устройств (в качестве чего выступает устройство).
 */
export enum DeviceType {
  /**
   * Значение не указано
   */
  TYPE_UNKNOWN = "TYPE_UNKNOWN",
  /**
   * Домофон
   */
  INTERCOM = "INTERCOM",
  /**
   * Видеокамера
   * @deprecated
   */
  VIDEOCAMERA = "VIDEOCAMERA",
  /**
   * Шлагбаум
   */
  BARRIER = "BARRIER",
  /**
   * Калитка
   */
  GATE = "GATE",
  /**
   * СКУД
   * @deprecated
   */
  ACCESS_CONTROL_PANEL = "ACCESS_CONTROL_PANEL",
  /**
   * Наружняя видеокамера
   * @deprecated
   */
  OUTDOOR_CAMERA = "OUTDOOR_CAMERA",
}
/**
 * Справочник назначений типов устройств (в качестве чего выступает устройство).
 */
export type DeviceTypeResponseEnum = keyof typeof DeviceType
/**
 * Справочник назначений типов устройств (в качестве чего выступает устройство).
 */
export type DeviceTypeRequestEnum = Exclude<DeviceTypeResponseEnum, "TYPE_UNKNOWN">;

/**
 * Тип конфигурации.
 */
export enum DeviceConfigurationStatusConfigurationType {
  /**
   * Значение не указано
   */
  CONFIGURATION_TYPE_UNKNOWN = "CONFIGURATION_TYPE_UNKNOWN",
  /**
   * Пресет
   */
  PRESET = "PRESET",
  /**
   * Сип-аккаунт
   */
  SIP_ACCOUNT = "SIP_ACCOUNT",
  /**
   * сип-номера в помещениях
   */
  SIP_ROOMS = "SIP_ROOMS",
  /**
   * Калитка
   */
  GATE = "GATE",
  /**
   * Ключи
   */
  RFIDS = "RFIDS",
  /**
   * Коды
   */
  CODES = "CODES",
  /**
   * Распознование лиц
   */
  FACE_RECOGNITION = "FACE_RECOGNITION",
  /**
   * Консьерж
   */
  CONCIERGE = "CONCIERGE",
  /**
   * Автосбор
   */
  AUTOCOLLECT = "AUTOCOLLECT",
  /**
   * Режим Sl3
   */
  SL3 = "SL3",
  /**
   * Вызов экстренной службы
   */
  EMERGENCY_CALL = "EMERGENCY_CALL",
}
/**
 * Тип конфигурации.
 */
export type DeviceConfigurationStatusConfigurationTypeResponseEnum = keyof typeof DeviceConfigurationStatusConfigurationType
/**
 * Тип конфигурации.
 */
export type DeviceConfigurationStatusConfigurationTypeRequestEnum = Exclude<DeviceConfigurationStatusConfigurationTypeResponseEnum, "CONFIGURATION_TYPE_UNKNOWN">;

/**
 * Справочник статусов конфигурации настройки устройства.
 */
export enum DeviceConfigurationStatusStatusType {
  /**
   * Значение не указано
   */
  STATUS_TYPE_UNKNOWN = "STATUS_TYPE_UNKNOWN",
  /**
   * Настроен
   */
  SUCCESS = "SUCCESS",
  /**
   * Ошибка
   */
  ERROR = "ERROR",
  /**
   * В ожидании обработки
   */
  PENDING = "PENDING",
  /**
   * В процессе обработки
   */
  PROCESSING = "PROCESSING",
}
/**
 * Справочник статусов конфигурации настройки устройства.
 */
export type DeviceConfigurationStatusStatusTypeResponseEnum = keyof typeof DeviceConfigurationStatusStatusType
/**
 * Справочник статусов конфигурации настройки устройства.
 */
export type DeviceConfigurationStatusStatusTypeRequestEnum = Exclude<DeviceConfigurationStatusStatusTypeResponseEnum, "STATUS_TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки.
 */
export enum DeviceConfigurationStatusGroupedPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки.
 */
export type DeviceConfigurationStatusGroupedPagingDirectionTypeResponseEnum = keyof typeof DeviceConfigurationStatusGroupedPagingDirectionType
/**
 * Справочник типов направлений сортировки.
 */
export type DeviceConfigurationStatusGroupedPagingDirectionTypeRequestEnum = Exclude<DeviceConfigurationStatusGroupedPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки.
 */
export enum DeviceConfigurationStatusGroupedPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По идентификатору устройства
   */
  DEVICE_ID = "DEVICE_ID",
}
/**
 * Справочник типов значений сортировки.
 */
export type DeviceConfigurationStatusGroupedPagingOrderByTypeResponseEnum = keyof typeof DeviceConfigurationStatusGroupedPagingOrderByType
/**
 * Справочник типов значений сортировки.
 */
export type DeviceConfigurationStatusGroupedPagingOrderByTypeRequestEnum = Exclude<DeviceConfigurationStatusGroupedPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки.
 */
export enum DevicePagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки.
 */
export type DevicePagingDirectionTypeResponseEnum = keyof typeof DevicePagingDirectionType
/**
 * Справочник типов направлений сортировки.
 */
export type DevicePagingDirectionTypeRequestEnum = Exclude<DevicePagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки.
 */
export enum DevicePagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По идентификатору
   */
  ID = "ID",
  /**
   * По наименованию
   */
  TITLE = "TITLE",
  /**
   * По дате последней попытки синхронизации
   */
  SYNC_AT = "SYNC_AT",
}
/**
 * Справочник типов значений сортировки.
 */
export type DevicePagingOrderByTypeResponseEnum = keyof typeof DevicePagingOrderByType
/**
 * Справочник типов значений сортировки.
 */
export type DevicePagingOrderByTypeRequestEnum = Exclude<DevicePagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Тип конфигурации.
 */
export enum PresetFaceRecognitionConfigurationType {
  /**
   * Значение не указано
   */
  CONFIGURATION_TYPE_UNKNOWN = "CONFIGURATION_TYPE_UNKNOWN",
  /**
   * По умолчанию
   */
  DEFAULT = "DEFAULT",
}
/**
 * Тип конфигурации.
 */
export type PresetFaceRecognitionConfigurationTypeResponseEnum = keyof typeof PresetFaceRecognitionConfigurationType
/**
 * Тип конфигурации.
 */
export type PresetFaceRecognitionConfigurationTypeRequestEnum = Exclude<PresetFaceRecognitionConfigurationTypeResponseEnum, "CONFIGURATION_TYPE_UNKNOWN">;

/**
 * Справочник статусов.
 */
export enum PresetStatusType {
  /**
   * Значение не указано
   */
  STATUS_TYPE_UNKNOWN = "STATUS_TYPE_UNKNOWN",
  /**
   * Активный
   */
  ACTIVE = "ACTIVE",
  /**
   * Архивный
   */
  ARCHIVE = "ARCHIVE",
}
/**
 * Справочник статусов.
 */
export type PresetStatusTypeResponseEnum = keyof typeof PresetStatusType
/**
 * Справочник статусов.
 */
export type PresetStatusTypeRequestEnum = Exclude<PresetStatusTypeResponseEnum, "STATUS_TYPE_UNKNOWN">;

/**
 * Тип протокола.
 */
export enum PresetSyslogProtocolType {
  /**
   * Значение не указано
   */
  PROTOCOL_TYPE_UNKNOWN = "PROTOCOL_TYPE_UNKNOWN",
  /**
   * Протокол UDP
   */
  UDP = "UDP",
  /**
   * Протокол TCP
   */
  TCP = "TCP",
}
/**
 * Тип протокола.
 */
export type PresetSyslogProtocolTypeResponseEnum = keyof typeof PresetSyslogProtocolType
/**
 * Тип протокола.
 */
export type PresetSyslogProtocolTypeRequestEnum = Exclude<PresetSyslogProtocolTypeResponseEnum, "PROTOCOL_TYPE_UNKNOWN">;

/**
 * Справочник качеств.
 */
export enum PresetVideoConfigQualityType {
  /**
   * Значение не указано
   */
  QUALITY_TYPE_UNKNOWN = "QUALITY_TYPE_UNKNOWN",
  /**
   * Высокое качество
   */
  HIGH = "HIGH",
  /**
   * Среднее качество
   */
  MEDIUM = "MEDIUM",
}
/**
 * Справочник качеств.
 */
export type PresetVideoConfigQualityTypeResponseEnum = keyof typeof PresetVideoConfigQualityType
/**
 * Справочник качеств.
 */
export type PresetVideoConfigQualityTypeRequestEnum = Exclude<PresetVideoConfigQualityTypeResponseEnum, "QUALITY_TYPE_UNKNOWN">;

/**
 * Статус синхронизации.
 */
export enum SyncStatusStatusType {
  /**
   * Значение не указано
   */
  STATUS_TYPE_UNKNOWN = "STATUS_TYPE_UNKNOWN",
  /**
   * Новый
   */
  NEW = "NEW",
  /**
   * В процессе
   */
  PENDING = "PENDING",
  /**
   * Ошибка
   */
  ERROR = "ERROR",
  /**
   * Успешно
   */
  SUCCESS = "SUCCESS",
  /**
   * Выключено
   */
  DISABLED = "DISABLED",
}
/**
 * Статус синхронизации.
 */
export type SyncStatusStatusTypeResponseEnum = keyof typeof SyncStatusStatusType
/**
 * Статус синхронизации.
 */
export type SyncStatusStatusTypeRequestEnum = Exclude<SyncStatusStatusTypeResponseEnum, "STATUS_TYPE_UNKNOWN">;

/**
 * Статус камеры.
 * # Описание модели
 */
export type CameraStatusRequestDto = {
  /**
   * Идентификатор камеры uid.
   * # Тип: Guid
   */
  id?: string | null
}
/**
 * Статус камеры.
 * # Описание модели
 */
export type CameraStatusResponseDto = {
  /**
   * Идентификатор камеры uid.
   * # Тип: Guid
   */
  id: string | null
  /**
   * Статус камеры
   */
  readonly statusType: CameraStatusStatusTypeResponseEnum
  /**
   * Сообщение об ошибке
   */
  readonly errorMessage: string
}
/**
 * Запрос удаления устройства
 */
export type DeleteDeviceRequestDto = {
  /**
   * Идентификатор устройства
   */
  id: number
}
/**
 * Ответ на запрос удаления устройства
 */
export type DeleteDeviceResponseDto = {
}
/**
 * Устройство.
 * # Описание модели
 */
export type DeviceRequestDto = {
  /**
   * Идентификатор.
   * # Диапазон: 0..2147483647
   */
  id?: number
  /**
   * Идентификатор пресета.
   * # Диапазон: 1..2147483647
   */
  presetId: number
  /**
   * Настройка режима SL3
   * @deprecated
   */
  isSl3ModeEnabled: boolean
  /**
   * Тип назначения устройства
   */
  type: DeviceTypeRequestEnum
  /**
   * MAC-адрес.
   * # Диапазон: 17..17.
   * # Паттерн: /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/
   */
  macAddress: string
  /**
   * Наименование устройства.
   * # Диапазон: 3..256
   */
  title: string
  /**
   * Модель устройства
   */
  modelType: DeviceModelTypeRequestEnum
  /**
   * Идентификатор компании владельца.
   * # Диапазон: 1..2147483647
   */
  ownerCompanyId: number
  /**
   * Серийный номер.
   * # Диапазон: 1..16
   */
  serialNumber: string
  /**
   * Идентификатор квартирограммы.
   * # Диапазон: 1..2147483647
   */
  flatgrammId: number
  /**
   * Смещение таймзоны в минутах.
   * # Диапазон: -720..840
   */
  utcOffset: number
  /**
   * Сетевой адрес.
   * # Диапазон: 0..250
   */
  ipAddress?: string | null
  /**
   * Сетевой порт.
   * # Диапазон: 0..65535
   */
  port?: number | null
  /**
   * Учетные данные.
   * Используется для устройств с типом модели SPUTNIK_IO
   */
  sputnikCredentials?: DeviceSputnikCredentialsRequestDto | null
  /**
   * Координаты
   */
  location?: DeviceLocationRequestDto | null
  /**
   * Идентификатор камеры uid.
   * # Тип: Guid
   */
  cameraId?: string | null
  /**
   * Список тегов устройства.
   * # Диапазон: 1..50
   */
  tags?: string[]
  /**
   * Настройки устройства
   */
  settings?: DeviceSettingsRequestDto | null
  /**
   * Диспетчеризации
   */
  dispatching?: DeviceDispatchingRequestDto | null
  /**
   * Транк
   */
  sipTrunk?: DeviceSipTrunkRequestDto | null
  /**
   * Переадресация
   */
  redirect?: DeviceRedirectRequestDto | null
  /**
   * Настройки автозамены пароля
   */
  autochangePasswordSettings?: DeviceAutochangePasswordSettingsRequestDto | null
}
/**
 * Устройство.
 * # Описание модели
 */
export type DeviceResponseDto = {
  /**
   * Идентификатор.
   * # Диапазон: 0..2147483647
   */
  id: number
  /**
   * Идентификатор пресета.
   * # Диапазон: 1..2147483647
   */
  presetId: number
  /**
   * Статус установки пресета.
   * # Поле вычисляется в коде приложения
   * @deprecated
   */
  readonly presetStatusType: DevicePresetStatusTypeResponseEnum
  /**
   * Дата установки пресета на устройство.
   * # Тип: DateTime
   * @deprecated
   */
  readonly presetConfiguredAt: string | null
  /**
   * Настройка режима SL3
   * @deprecated
   */
  isSl3ModeEnabled: boolean
  /**
   * Тип назначения устройства
   */
  type: DeviceTypeResponseEnum
  /**
   * MAC-адрес.
   * # Диапазон: 17..17.
   * # Паттерн: /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/
   */
  macAddress: string
  /**
   * Наименование устройства.
   * # Диапазон: 3..256
   */
  title: string
  /**
   * Модель устройства
   */
  modelType: DeviceModelTypeResponseEnum
  /**
   * Идентификатор компании владельца.
   * # Диапазон: 1..2147483647
   */
  ownerCompanyId: number
  /**
   * Серийный номер.
   * # Диапазон: 1..16
   */
  serialNumber: string
  /**
   * Идентификатор квартирограммы.
   * # Диапазон: 1..2147483647
   */
  flatgrammId: number
  /**
   * Смещение таймзоны в минутах.
   * # Диапазон: -720..840
   */
  utcOffset: number
  /**
   * Статус устройства
   */
  readonly statusType: DeviceStatusTypeResponseEnum
  /**
   * Сетевой адрес.
   * # Диапазон: 0..250
   */
  ipAddress: string | null
  /**
   * Сетевой порт.
   * # Диапазон: 0..65535
   */
  port: number | null
  /**
   * Учетные данные.
   * Используется для устройств с типом модели SPUTNIK_IO
   */
  sputnikCredentials: DeviceSputnikCredentialsResponseDto | null
  /**
   * Координаты
   */
  location: DeviceLocationResponseDto | null
  /**
   * Идентификатор камеры uid.
   * # Тип: Guid
   */
  cameraId: string | null
  /**
   * Список тегов устройства.
   * # Диапазон: 1..50
   */
  tags: string[]
  /**
   * Настройки устройства
   */
  settings: DeviceSettingsResponseDto | null
  /**
   * Версия аппаратного обеспенения
   */
  readonly hardwareVersion: string
  /**
   * Версия программного обеспенения
   */
  readonly softwareVersion: string
  /**
   * Диспетчеризации
   */
  dispatching: DeviceDispatchingResponseDto | null
  /**
   * Транк
   */
  sipTrunk: DeviceSipTrunkResponseDto | null
  /**
   * Переадресация
   */
  redirect: DeviceRedirectResponseDto | null
  /**
   * Настройки автозамены пароля
   */
  autochangePasswordSettings: DeviceAutochangePasswordSettingsResponseDto | null
  /**
   * Учетные данные пользователей
   */
  readonly credentials: DeviceCredentialsResponseDto[]
  /**
   * Сип-аккаунт
   */
  readonly sipAccount: string | null
  /**
   * Статус синхронизации
   */
  readonly syncStatus: SyncStatusResponseDto | null
}
/**
 * Настройки автозамены пароля
 */
export type DeviceAutochangePasswordSettingsRequestDto = {
  /**
   * Статус настройки автозамены пароля
   */
  isEnabled: boolean
}
/**
 * Настройки автозамены пароля
 */
export type DeviceAutochangePasswordSettingsResponseDto = {
  /**
   * Статус настройки автозамены пароля
   */
  isEnabled: boolean
}
/**
 * Учетные данные пользователей
 */
export type DeviceCredentialsRequestDto = {
  /**
   * Логин.
   * # Диапазон: 0..100
   */
  login?: string | null
  /**
   * Пароль.
   * # Диапазон: 0..100
   */
  password?: string | null
  /**
   * Тип доступа пользователя
   */
  userAccessType?: DeviceCredentialsUserAccessTypeRequestEnum | "USER_ACCESS_TYPE_UNKNOWN"
}
/**
 * Учетные данные пользователей
 */
export type DeviceCredentialsResponseDto = {
  /**
   * Логин.
   * # Диапазон: 0..100
   */
  login: string | null
  /**
   * Пароль.
   * # Диапазон: 0..100
   */
  password: string | null
  /**
   * Тип доступа пользователя
   */
  userAccessType: DeviceCredentialsUserAccessTypeResponseEnum
}
/**
 * Диспетчеризации
 */
export type DeviceDispatchingRequestDto = {
  /**
   * Статус настройки диспетчеризации
   */
  isEnabled: boolean
  /**
   * Публичный номер.
   * # Паттерн: /^[1-9]\d{3,7}$/
   */
  publicIdentity?: string | null
}
/**
 * Диспетчеризации
 */
export type DeviceDispatchingResponseDto = {
  /**
   * Статус настройки диспетчеризации
   */
  isEnabled: boolean
  /**
   * Публичный номер.
   * # Паттерн: /^[1-9]\d{3,7}$/
   */
  publicIdentity: string | null
}
/**
 * Координаты
 */
export type DeviceLocationRequestDto = {
  /**
   * Широта
   */
  latitude: number
  /**
   * Долгота
   */
  longitude: number
}
/**
 * Координаты
 */
export type DeviceLocationResponseDto = {
  /**
   * Широта
   */
  latitude: number
  /**
   * Долгота
   */
  longitude: number
}
/**
 * Переадресация.
 * Требуется капабилити SIP_CALLS
 */
export type DeviceRedirectRequestDto = {
  /**
   * Переадресация на SIP
   */
  isEnabledSip: boolean
  /**
   * Переадресация на телефон
   */
  isEnabledPhone: boolean
}
/**
 * Переадресация.
 * Требуется капабилити SIP_CALLS
 */
export type DeviceRedirectResponseDto = {
  /**
   * Переадресация на SIP
   */
  isEnabledSip: boolean
  /**
   * Переадресация на телефон
   */
  isEnabledPhone: boolean
}
/**
 * Ошибка сохранения.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type DeviceSavingErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Переданный мак-адрес не валидный
   * @deprecated
   */
  readonly macAddressInvalid: DeviceSavingErrorMacAddressInvalidRequestDto
  /**
   * Переданный серийный номер не валидный
   * @deprecated
   */
  readonly serialNumberInvalid: DeviceSavingErrorSerialNumberInvalidRequestDto
  /**
   * Нельзя изменить тип назначения девайса
   */
  readonly notAllowedForType: DeviceSavingErrorNotAllowedForTypeRequestDto
  /**
   * Нельзя изменить модель девайса
   */
  readonly notAllowedForModel: DeviceSavingErrorNotAllowedForModelRequestDto
  /**
   * Серийный номер для данной модели уже существует на платформе
   */
  readonly serialNumberForModelIsExist: DeviceSavingErrorSerialNumberForModelIsExistRequestDto
  /**
   * MAC-адрес уже существует на платформе
   */
  readonly macAddressIsExist: DeviceSavingErrorMacAddressIsExistRequestDto
  /**
   * Настройка не поддерживается
   */
  readonly capabilityIsNotSupported: DeviceSavingErrorCapabilityIsNotSupportedRequestDto
  /**
   * ABC-номер присвоен другому устройству
   */
  readonly abcNumberIsExistOnAnotherDevice: DeviceSavingErrorAbcNumberIsExistOnAnotherDeviceRequestDto
  /**
   * Публичный номер уже существует на платформе
   */
  readonly publicIdentityIsExist: DeviceSavingErrorPublicIdentityIsExistRequestDto
  /**
   * Не найдена квартира для консьержа
   */
  readonly conciergeRoomNotFound: DeviceSavingErrorConciergeRoomNotFoundRequestDto
  /**
   * Логин уже существует на платформе
   */
  readonly loginIsExist: DeviceSavingErrorLoginIsExistRequestDto
  /**
   * Отсутствуют реквизиты для модели \"Спутник\"
   */
  readonly credentialsAreRequired: DeviceSavingErrorCredentialsAreRequiredRequestDto
  /**
   * Переданное поле не поддерживается
   */
  readonly fieldIsNotSupported: DeviceSavingErrorFieldIsNotSupportedRequestDto
}>
/**
 * Ошибка сохранения.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type DeviceSavingErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Переданный мак-адрес не валидный
   * @deprecated
   */
  readonly macAddressInvalid: DeviceSavingErrorMacAddressInvalidResponseDto
  /**
   * Переданный серийный номер не валидный
   * @deprecated
   */
  readonly serialNumberInvalid: DeviceSavingErrorSerialNumberInvalidResponseDto
  /**
   * Нельзя изменить тип назначения девайса
   */
  readonly notAllowedForType: DeviceSavingErrorNotAllowedForTypeResponseDto
  /**
   * Нельзя изменить модель девайса
   */
  readonly notAllowedForModel: DeviceSavingErrorNotAllowedForModelResponseDto
  /**
   * Серийный номер для данной модели уже существует на платформе
   */
  readonly serialNumberForModelIsExist: DeviceSavingErrorSerialNumberForModelIsExistResponseDto
  /**
   * MAC-адрес уже существует на платформе
   */
  readonly macAddressIsExist: DeviceSavingErrorMacAddressIsExistResponseDto
  /**
   * Настройка не поддерживается
   */
  readonly capabilityIsNotSupported: DeviceSavingErrorCapabilityIsNotSupportedResponseDto
  /**
   * ABC-номер присвоен другому устройству
   */
  readonly abcNumberIsExistOnAnotherDevice: DeviceSavingErrorAbcNumberIsExistOnAnotherDeviceResponseDto
  /**
   * Публичный номер уже существует на платформе
   */
  readonly publicIdentityIsExist: DeviceSavingErrorPublicIdentityIsExistResponseDto
  /**
   * Не найдена квартира для консьержа
   */
  readonly conciergeRoomNotFound: DeviceSavingErrorConciergeRoomNotFoundResponseDto
  /**
   * Логин уже существует на платформе
   */
  readonly loginIsExist: DeviceSavingErrorLoginIsExistResponseDto
  /**
   * Отсутствуют реквизиты для модели \"Спутник\"
   */
  readonly credentialsAreRequired: DeviceSavingErrorCredentialsAreRequiredResponseDto
  /**
   * Переданное поле не поддерживается
   */
  readonly fieldIsNotSupported: DeviceSavingErrorFieldIsNotSupportedResponseDto
}>
/**
 * ABC-номер присвоен другому устройству
 */
export type DeviceSavingErrorAbcNumberIsExistOnAnotherDeviceRequestDto = {
  /**
   * Идентификатор устройства на котором находится ABC-номер
   */
  deviceId: number
}
/**
 * ABC-номер присвоен другому устройству
 */
export type DeviceSavingErrorAbcNumberIsExistOnAnotherDeviceResponseDto = {
  /**
   * Идентификатор устройства на котором находится ABC-номер
   */
  deviceId: number
}
/**
 * Функциональность не поддерживается моделью устройства
 */
export type DeviceSavingErrorCapabilityIsNotSupportedRequestDto = {
  /**
   * Возможность
   */
  modelCapabilityType?: modelV1.ModelCapabilityTypeRequestEnum | "CAPABILITY_TYPE_UNKNOWN"
}
/**
 * Функциональность не поддерживается моделью устройства
 */
export type DeviceSavingErrorCapabilityIsNotSupportedResponseDto = {
  /**
   * Возможность
   */
  modelCapabilityType: modelV1.ModelCapabilityTypeResponseEnum
}
/**
 * Не найдена квартира для консьержа
 */
export type DeviceSavingErrorConciergeRoomNotFoundRequestDto = {
}
/**
 * Не найдена квартира для консьержа
 */
export type DeviceSavingErrorConciergeRoomNotFoundResponseDto = {
}
/**
 * Отсутствуют реквизиты для модели \"Спутник\"
 */
export type DeviceSavingErrorCredentialsAreRequiredRequestDto = {
}
/**
 * Отсутствуют реквизиты для модели \"Спутник\"
 */
export type DeviceSavingErrorCredentialsAreRequiredResponseDto = {
}
/**
 * Переданное поле не поддерживается
 */
export type DeviceSavingErrorFieldIsNotSupportedRequestDto = {
}
/**
 * Переданное поле не поддерживается
 */
export type DeviceSavingErrorFieldIsNotSupportedResponseDto = {
}
/**
 * Логин уже существует на платформе
 */
export type DeviceSavingErrorLoginIsExistRequestDto = {
}
/**
 * Логин уже существует на платформе
 */
export type DeviceSavingErrorLoginIsExistResponseDto = {
}
/**
 * Переданный мак-адрес не валидный
 */
export type DeviceSavingErrorMacAddressInvalidRequestDto = {
}
/**
 * Переданный мак-адрес не валидный
 */
export type DeviceSavingErrorMacAddressInvalidResponseDto = {
}
/**
 * MAC-адрес уже существует на платформе
 */
export type DeviceSavingErrorMacAddressIsExistRequestDto = {
}
/**
 * MAC-адрес уже существует на платформе
 */
export type DeviceSavingErrorMacAddressIsExistResponseDto = {
}
/**
 * Нельзя изменить модель девайса
 */
export type DeviceSavingErrorNotAllowedForModelRequestDto = {
}
/**
 * Нельзя изменить модель девайса
 */
export type DeviceSavingErrorNotAllowedForModelResponseDto = {
}
/**
 * Нельзя изменить тип назначения девайса
 */
export type DeviceSavingErrorNotAllowedForTypeRequestDto = {
}
/**
 * Нельзя изменить тип назначения девайса
 */
export type DeviceSavingErrorNotAllowedForTypeResponseDto = {
}
/**
 * Публичный номер уже существует на платформе
 */
export type DeviceSavingErrorPublicIdentityIsExistRequestDto = {
}
/**
 * Публичный номер уже существует на платформе
 */
export type DeviceSavingErrorPublicIdentityIsExistResponseDto = {
}
/**
 * Серийный номер для данной модели уже существует на платформе
 */
export type DeviceSavingErrorSerialNumberForModelIsExistRequestDto = {
}
/**
 * Серийный номер для данной модели уже существует на платформе
 */
export type DeviceSavingErrorSerialNumberForModelIsExistResponseDto = {
}
/**
 * Переданный серийный номер не валидный
 */
export type DeviceSavingErrorSerialNumberInvalidRequestDto = {
}
/**
 * Переданный серийный номер не валидный
 */
export type DeviceSavingErrorSerialNumberInvalidResponseDto = {
}
/**
 * Настройки устройства
 */
export type DeviceSettingsRequestDto = {
  /**
   * Настройки ККМ
   */
  coordinateMatrixSwitch?: DeviceSettingsCoordinateMatrixSwitchRequestDto | null
  /**
   * Настройки вызова консьержа.
   * Требуется капабилити CONCIERGE_CALL
   */
  conciergeCall?: DeviceSettingsConciergeCallRequestDto | null
  /**
   * Настройки автосбора
   */
  autocollect?: DeviceSettingsAutocollectRequestDto | null
  /**
   * Настройки распознования лиц
   */
  faceRecognition?: DeviceSettingsFaceRecognitionRequestDto | null
  /**
   * Настройки режима SL3
   */
  sl3Mode?: DeviceSettingsSl3ModeRequestDto | null
  /**
   * Настройки вызова экстренной службы.
   * Только для устройств с CapabilityType=EMERGENCY_CALL
   */
  emergencyCall?: DeviceSettingsEmergencyCallRequestDto | null
}
/**
 * Настройки устройства
 */
export type DeviceSettingsResponseDto = {
  /**
   * Настройки ККМ
   */
  coordinateMatrixSwitch: DeviceSettingsCoordinateMatrixSwitchResponseDto | null
  /**
   * Настройки вызова консьержа.
   * Требуется капабилити CONCIERGE_CALL
   */
  conciergeCall: DeviceSettingsConciergeCallResponseDto | null
  /**
   * Настройки автосбора
   */
  autocollect: DeviceSettingsAutocollectResponseDto | null
  /**
   * Настройки распознования лиц
   */
  faceRecognition: DeviceSettingsFaceRecognitionResponseDto | null
  /**
   * Настройки режима SL3
   */
  sl3Mode: DeviceSettingsSl3ModeResponseDto | null
  /**
   * Настройки вызова экстренной службы.
   * Только для устройств с CapabilityType=EMERGENCY_CALL
   */
  emergencyCall: DeviceSettingsEmergencyCallResponseDto | null
}
/**
 * Настройки автосбора
 */
export type DeviceSettingsAutocollectRequestDto = {
  /**
   * Статус настройки автосбора
   */
  isEnabled: boolean
}
/**
 * Настройки автосбора
 */
export type DeviceSettingsAutocollectResponseDto = {
  /**
   * Статус настройки автосбора
   */
  isEnabled: boolean
}
/**
 * Настройки вызова консьержа
 */
export type DeviceSettingsConciergeCallRequestDto = {
  /**
   * Статус настройки вызова консьержа
   */
  isEnabled: boolean
  /**
   * Идентификатор ОРПОН
   */
  orpon: string
  /**
   * Номер квартиры.
   * # Диапазон: 1..5
   */
  roomNumber: string
}
/**
 * Настройки вызова консьержа
 */
export type DeviceSettingsConciergeCallResponseDto = {
  /**
   * Статус настройки вызова консьержа
   */
  isEnabled: boolean
  /**
   * Идентификатор ОРПОН
   */
  orpon: string
  /**
   * Номер квартиры.
   * # Диапазон: 1..5
   */
  roomNumber: string
  /**
   * Номер сип-трубки
   */
  readonly sipNumber: string
}
/**
 * Настройки ККМ.
 * Коммутатор координатно-матричный (устройство для подключения аналоговых трубок к домофону)
 */
export type DeviceSettingsCoordinateMatrixSwitchRequestDto = {
  /**
   * Состояние
   */
  isEnabled: boolean
}
/**
 * Настройки ККМ.
 * Коммутатор координатно-матричный (устройство для подключения аналоговых трубок к домофону)
 */
export type DeviceSettingsCoordinateMatrixSwitchResponseDto = {
  /**
   * Состояние
   */
  isEnabled: boolean
}
/**
 * Настройки вызова экстренной службы.
 * Только для устройств с CapabilityType=EMERGENCY_CALL
 */
export type DeviceSettingsEmergencyCallRequestDto = {
  /**
   * Возможность вызова экстренной службы
   */
  isCallAvailable: boolean
  /**
   * АБС-номер экстренной службы.
   * # Паттерн: /^\+[1-9][0-9]{10}$/
   */
  emergencyNumber: string
}
/**
 * Настройки вызова экстренной службы.
 * Только для устройств с CapabilityType=EMERGENCY_CALL
 */
export type DeviceSettingsEmergencyCallResponseDto = {
  /**
   * Возможность вызова экстренной службы
   */
  isCallAvailable: boolean
  /**
   * АБС-номер экстренной службы.
   * # Паттерн: /^\+[1-9][0-9]{10}$/
   */
  emergencyNumber: string
}
/**
 * Настройки распознования лиц
 */
export type DeviceSettingsFaceRecognitionRequestDto = {
  /**
   * Статус настройки
   */
  isEnabled: boolean
}
/**
 * Настройки распознования лиц
 */
export type DeviceSettingsFaceRecognitionResponseDto = {
  /**
   * Статус настройки
   */
  isEnabled: boolean
}
/**
 * Настройки режима SL3
 */
export type DeviceSettingsSl3ModeRequestDto = {
  /**
   * Статус настройки
   */
  isEnabled: boolean
  /**
   * Идентификатор профиля шифрования
   */
  encryptionProfileId?: string | null
}
/**
 * Настройки режима SL3
 */
export type DeviceSettingsSl3ModeResponseDto = {
  /**
   * Статус настройки
   */
  isEnabled: boolean
  /**
   * Идентификатор профиля шифрования
   */
  encryptionProfileId: string | null
}
/**
 * Транк.
 * Параметры для соединения между устрйоством и телефонной сетью общего пользования.
 * Требуется капабилити SIP_CALLS
 */
export type DeviceSipTrunkRequestDto = {
  /**
   * ABC-номер.
   * # Паттерн: /^(\+7)(\d{10})$/
   */
  abcNumber: string
  /**
   * Хост.
   * # Диапазон: 0..250
   */
  host?: string | null
  /**
   * Порт.
   * # Диапазон: 0..65535
   */
  port?: number | null
  /**
   * Тип сети связи
   */
  sipType: DeviceSipTrunkSipTypeRequestEnum
}
/**
 * Транк.
 * Параметры для соединения между устрйоством и телефонной сетью общего пользования.
 * Требуется капабилити SIP_CALLS
 */
export type DeviceSipTrunkResponseDto = {
  /**
   * ABC-номер.
   * # Паттерн: /^(\+7)(\d{10})$/
   */
  abcNumber: string
  /**
   * Хост.
   * # Диапазон: 0..250
   */
  host: string | null
  /**
   * Порт.
   * # Диапазон: 0..65535
   */
  port: number | null
  /**
   * Тип сети связи
   */
  sipType: DeviceSipTrunkSipTypeResponseEnum
}
/**
 * Учетные данные.
 * Используется для устройств с типом модели SPUTNIK_IO
 */
export type DeviceSputnikCredentialsRequestDto = {
  /**
   * Логин.
   * # Тип: Guid
   */
  login: string
  /**
   * Пароль.
   * На чтение выводится только для пользователя с типом service
   */
  password?: string | null
}
/**
 * Учетные данные.
 * Используется для устройств с типом модели SPUTNIK_IO
 */
export type DeviceSputnikCredentialsResponseDto = {
  /**
   * Логин.
   * # Тип: Guid
   */
  login: string
  /**
   * Пароль.
   * На чтение выводится только для пользователя с типом service
   */
  password: string | null
}
/**
 * Статус конфигурации устройства.
 * # Описание модели
 */
export type DeviceConfigurationStatusRequestDto = {
  /**
   * Идентификатор
   */
  id?: number
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Тип конфигурации
   */
  configurationType: DeviceConfigurationStatusConfigurationTypeRequestEnum
  /**
   * Статус конфигурации настройки устройства
   */
  statusType: DeviceConfigurationStatusStatusTypeRequestEnum
  /**
   * Текст ошибки
   */
  errorMessage?: string | null
  /**
   * Количество попыток
   */
  retryCount: number
}
/**
 * Статус конфигурации устройства.
 * # Описание модели
 */
export type DeviceConfigurationStatusResponseDto = {
  /**
   * Идентификатор
   */
  id: number
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Тип конфигурации
   */
  configurationType: DeviceConfigurationStatusConfigurationTypeResponseEnum
  /**
   * Статус конфигурации настройки устройства
   */
  statusType: DeviceConfigurationStatusStatusTypeResponseEnum
  /**
   * Дата последней конфигурации устройства.
   * # Тип: DateTime
   */
  readonly configuredAt: string | null
  /**
   * Текст ошибки
   */
  errorMessage: string | null
  /**
   * Количество попыток
   */
  retryCount: number
  /**
   * Дополнительная полезная нагрузка
   */
  readonly payload: DeviceConfigurationStatusPayloadResponseDto | null
  /**
   * Минимально возможная дата выполнения следующей попытки.
   * # Тип: DateTime
   */
  readonly nextRetryAt: string | null
}
/**
 * Дополнительная полезная нагрузка
 */
export type DeviceConfigurationStatusPayloadRequestDto = {
}
/**
 * attribute
 */
& fm.OptionalOneOf<{
  /**
   * Автоколлект
   */
  readonly autocollect: DeviceConfigurationStatusPayloadAutocollectRequestDto
}>
/**
 * Дополнительная полезная нагрузка
 */
export type DeviceConfigurationStatusPayloadResponseDto = {
}
/**
 * attribute
 */
& fm.OneOf<{
  /**
   * Автоколлект
   */
  readonly autocollect: DeviceConfigurationStatusPayloadAutocollectResponseDto
}>
/**
 * Автоколлект
 */
export type DeviceConfigurationStatusPayloadAutocollectRequestDto = {
  /**
   * Дата включения автосбора.
   * # Тип: DateTime
   */
  enabledAt?: string | null
  /**
   * Дата отключения автосбора.
   * # Тип: DateTime
   */
  toBeDisabledAt?: string | null
}
/**
 * Автоколлект
 */
export type DeviceConfigurationStatusPayloadAutocollectResponseDto = {
  /**
   * Дата включения автосбора.
   * # Тип: DateTime
   */
  enabledAt: string | null
  /**
   * Дата отключения автосбора.
   * # Тип: DateTime
   */
  toBeDisabledAt: string | null
}
/**
 * Сгруппированный по устройству список конфигураций
 */
export type DeviceConfigurationStatusGroupedRequestDto = {
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Список конфигураций
   */
  statuses: DeviceConfigurationStatusRequestDto[]
}
/**
 * Сгруппированный по устройству список конфигураций
 */
export type DeviceConfigurationStatusGroupedResponseDto = {
  /**
   * Идентификатор устройства
   */
  deviceId: number
  /**
   * Список конфигураций
   */
  statuses: DeviceConfigurationStatusResponseDto[]
}
/**
 * Фильтр конфигураций сгруппированных по устройству
 */
export type DeviceConfigurationStatusGroupedFilterRequestDto = {
  /**
   * По идентификаторам устройства
   */
  deviceIds?: number[]
  /**
   * По типам конфигурации
   */
  configurationTypes?: DeviceConfigurationStatusConfigurationTypeResponseEnum[]
  /**
   * По статусам конфигурации настройки
   */
  statusTypes?: DeviceConfigurationStatusStatusTypeResponseEnum[]
  /**
   * Флаг, указывающий на готовность настройки к конфигурированию.
   * Значение next_retry_at меньше текущей даты
   */
  isReadyForRetry?: boolean | null
  /**
   * Пороговое значение количества попыток.
   * Возвращает записи, у которых retry_count меньше этого значения
   */
  retryCountLessThen?: number | null
}
/**
 * Фильтр конфигураций сгруппированных по устройству
 */
export type DeviceConfigurationStatusGroupedFilterResponseDto = {
  /**
   * По идентификаторам устройства
   */
  deviceIds: number[]
  /**
   * По типам конфигурации
   */
  configurationTypes: DeviceConfigurationStatusConfigurationTypeResponseEnum[]
  /**
   * По статусам конфигурации настройки
   */
  statusTypes: DeviceConfigurationStatusStatusTypeResponseEnum[]
  /**
   * Флаг, указывающий на готовность настройки к конфигурированию.
   * Значение next_retry_at меньше текущей даты
   */
  isReadyForRetry: boolean | null
  /**
   * Пороговое значение количества попыток.
   * Возвращает записи, у которых retry_count меньше этого значения
   */
  retryCountLessThen: number | null
}
/**
 * Постраничный вывод конфигураций сгруппированных по устройству
 */
export type DeviceConfigurationStatusGroupedPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: DEVICE_ID
   */
  orderByType?: DeviceConfigurationStatusGroupedPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType?: DeviceConfigurationStatusGroupedPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..1000.
   * # По умолчанию: 20
   */
  limit?: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset?: number
}
/**
 * Постраничный вывод конфигураций сгруппированных по устройству
 */
export type DeviceConfigurationStatusGroupedPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: DEVICE_ID
   */
  orderByType: DeviceConfigurationStatusGroupedPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType: DeviceConfigurationStatusGroupedPagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..1000.
   * # По умолчанию: 20
   */
  limit: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset: number
}
/**
 * Фильтр устройств
 */
export type DeviceFilterRequestDto = {
  /**
   * По идентификаторам компании владельца
   */
  ownerCompanyIds?: number[]
  /**
   * Поиск по тексту.
   * Если значение не передано то поиск по нему не производится.
   * # Диапазон: 3..64.
   * # Поиск производится по полям:
   * # - Наименование;
   * # - MAC-адрес;
   * # - Список тегов устройства;
   * # - Сетевой адрес;
   * # - Серийный номер
   */
  text?: string | null
  /**
   * Идентификатор квартирограммы
   */
  flatgrammIds?: number[]
  /**
   * Серийный номер
   */
  serialNumbers?: string[]
  /**
   * Статус устройства
   */
  deviceStatusTypes?: DeviceStatusTypeResponseEnum[]
  /**
   * Тип назначения устройства
   */
  deviceTypes?: DeviceTypeResponseEnum[]
  /**
   * Модель устройства
   */
  deviceModelTypes?: DeviceModelTypeResponseEnum[]
  /**
   * Переадресация на консъержа
   */
  isConciergeEnabled?: boolean | null
  /**
   * Диспетчеризация
   */
  isDispatchingEnabled?: boolean | null
  /**
   * Поиск по публичному номеру диспетчеризации.
   * Если значение не передано то поиск по нему не производится.
   * # Диапазон: 3..64
   */
  dispatchingPublicNumber?: string | null
  /**
   * Версия аппаратного обеспенения.
   * # Диапазон: 3..64
   */
  hardwareVersion?: string | null
  /**
   * Версия программного обеспенения.
   * # Диапазон: 3..64
   */
  softwareVersion?: string | null
  /**
   * Автозамена пароля
   */
  isAutochangePasswordEnabled?: boolean | null
  /**
   * ABC-номер
   */
  abcNumber?: string[]
  /**
   * Идентификаторы камер
   */
  cameraIds?: string[]
  /**
   * Фильтр по статусу синхронизации (SyncStatus.status_type)
   */
  syncStatusStatusTypes?: SyncStatusStatusTypeResponseEnum[]
  /**
   * Пороговое значение количества попыток синхронизации.
   * Возвращает записи, у которых sync_retry_count меньше этого значения
   */
  syncRetryCountLessThen?: number | null
  /**
   * От даты успешной синхронизации включительно (>=)
   */
  beginSyncSuccessfulAt?: string | null
  /**
   * До даты успешной синхронизации (<)
   */
  endSyncSuccessfulAt?: string | null
  /**
   * От даты синхронизации включительно (>=)
   */
  beginSyncAt?: string | null
  /**
   * До даты синхронизации (<)
   */
  endSyncAt?: string | null
}
/**
 * Фильтр устройств
 */
export type DeviceFilterResponseDto = {
  /**
   * По идентификаторам компании владельца
   */
  ownerCompanyIds: number[]
  /**
   * Поиск по тексту.
   * Если значение не передано то поиск по нему не производится.
   * # Диапазон: 3..64.
   * # Поиск производится по полям:
   * # - Наименование;
   * # - MAC-адрес;
   * # - Список тегов устройства;
   * # - Сетевой адрес;
   * # - Серийный номер
   */
  text: string | null
  /**
   * Идентификатор квартирограммы
   */
  flatgrammIds: number[]
  /**
   * Серийный номер
   */
  serialNumbers: string[]
  /**
   * Статус устройства
   */
  deviceStatusTypes: DeviceStatusTypeResponseEnum[]
  /**
   * Тип назначения устройства
   */
  deviceTypes: DeviceTypeResponseEnum[]
  /**
   * Модель устройства
   */
  deviceModelTypes: DeviceModelTypeResponseEnum[]
  /**
   * Переадресация на консъержа
   */
  isConciergeEnabled: boolean | null
  /**
   * Диспетчеризация
   */
  isDispatchingEnabled: boolean | null
  /**
   * Поиск по публичному номеру диспетчеризации.
   * Если значение не передано то поиск по нему не производится.
   * # Диапазон: 3..64
   */
  dispatchingPublicNumber: string | null
  /**
   * Версия аппаратного обеспенения.
   * # Диапазон: 3..64
   */
  hardwareVersion: string | null
  /**
   * Версия программного обеспенения.
   * # Диапазон: 3..64
   */
  softwareVersion: string | null
  /**
   * Автозамена пароля
   */
  isAutochangePasswordEnabled: boolean | null
  /**
   * ABC-номер
   */
  abcNumber: string[]
  /**
   * Идентификаторы камер
   */
  cameraIds: string[]
  /**
   * Фильтр по статусу синхронизации (SyncStatus.status_type)
   */
  syncStatusStatusTypes: SyncStatusStatusTypeResponseEnum[]
  /**
   * Пороговое значение количества попыток синхронизации.
   * Возвращает записи, у которых sync_retry_count меньше этого значения
   */
  syncRetryCountLessThen: number | null
  /**
   * От даты успешной синхронизации включительно (>=)
   */
  beginSyncSuccessfulAt: string | null
  /**
   * До даты успешной синхронизации (<)
   */
  endSyncSuccessfulAt: string | null
  /**
   * От даты синхронизации включительно (>=)
   */
  beginSyncAt: string | null
  /**
   * До даты синхронизации (<)
   */
  endSyncAt: string | null
}
/**
 * Облегчённое устройство.
 * # Описание модели
 */
export type DeviceLiteRequestDto = {
  /**
   * Идентификатор.
   * # Диапазон: 0..2147483647
   */
  id?: number
  /**
   * Тип назначения устройства
   */
  type: DeviceTypeRequestEnum
  /**
   * # Диапазон: 3..256
   */
  title: string
  /**
   * Координаты
   */
  location?: DeviceLocationRequestDto | null
  /**
   * Статус устройства
   */
  statusType?: DeviceStatusTypeRequestEnum | "STATUS_TYPE_UNKNOWN"
}
/**
 * Облегчённое устройство.
 * # Описание модели
 */
export type DeviceLiteResponseDto = {
  /**
   * Идентификатор.
   * # Диапазон: 0..2147483647
   */
  id: number
  /**
   * Тип назначения устройства
   */
  type: DeviceTypeResponseEnum
  /**
   * # Диапазон: 3..256
   */
  title: string
  /**
   * Координаты
   */
  location: DeviceLocationResponseDto | null
  /**
   * Статус устройства
   */
  statusType: DeviceStatusTypeResponseEnum
}
/**
 * Постраничный вывод
 */
export type DevicePagingRequestDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: ID
   */
  orderByType?: DevicePagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType?: DevicePagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit?: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset?: number
}
/**
 * Постраничный вывод
 */
export type DevicePagingResponseDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: ID
   */
  orderByType: DevicePagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType: DevicePagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset: number
}
/**
 * Запрос получения количества конфигураций сгруппированных по устройству
 */
export type GetDeviceConfigurationStatusGroupedCountRequestDto = {
  /**
   * Фильтр
   */
  filter?: DeviceConfigurationStatusGroupedFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества конфигураций сгруппированных по устройству
 */
export type GetDeviceConfigurationStatusGroupedCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Количество
   */
  readonly data: number
}>
/**
 * Запрос получения списка конфигураций сгруппированных по устройству
 */
export type GetDeviceConfigurationStatusGroupedListRequestDto = {
  /**
   * Фильтр
   */
  filter?: DeviceConfigurationStatusGroupedFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Стандартный постраничный вывод
   */
  readonly paging: DeviceConfigurationStatusGroupedPagingRequestDto
}>
/**
 * Ответ на запрос получения списка конфигураций сгруппированных по устройству
 */
export type GetDeviceConfigurationStatusGroupedListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Конфигурации устройства
   */
  readonly data: DeviceConfigurationStatusGroupedResponseDto
  /**
   * Ошибка
   */
  readonly error: GetDeviceConfigurationStatusGroupedListResponseErrorDto
}>
/**
 * Ошибка
 */
export type GetDeviceConfigurationStatusGroupedListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка
 */
export type GetDeviceConfigurationStatusGroupedListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос получения статусов конфигурации устройства
 */
export type GetDeviceConfigurationStatusesRequestDto = {
  /**
   * Идентификатор
   */
  id: number
}
/**
 * Ответ на запрос получения статусов конфигурации устройства
 */
export type GetDeviceConfigurationStatusesResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Устройство
   */
  readonly data: GetDeviceConfigurationStatusesResponseStatusesDto
  /**
   * Ошибка
   */
  readonly error: GetDeviceConfigurationStatusesResponseErrorDto
}>
/**
 * Ошибка
 */
export type GetDeviceConfigurationStatusesResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validationError: ValidationErrorRequestDto
}>
/**
 * Ошибка
 */
export type GetDeviceConfigurationStatusesResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validationError: ValidationErrorResponseDto
}>
/**
 * Статусы
 */
export type GetDeviceConfigurationStatusesResponseStatusesDto = {
  /**
   * Статусы конфигурации устройства
   */
  deviceConfigurationStatuses: DeviceConfigurationStatusResponseDto[]
  /**
   * Статус камеры
   */
  cameraStatus: CameraStatusResponseDto | null
  /**
   * Статус синхронизации
   */
  syncStatus: SyncStatusResponseDto | null
  /**
   * Статус устройства
   */
  deviceStatusType: DeviceStatusTypeResponseEnum
}
/**
 * Запрос получения количества устройств
 */
export type GetDeviceCountRequestDto = {
  /**
   * Фильтр
   */
  filter?: DeviceFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества устройств
 */
export type GetDeviceCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Количество
   */
  readonly data: number
  /**
   * Ошибка
   */
  readonly error: GetDeviceCountResponseErrorDto
}>
/**
 * Ошибка
 */
export type GetDeviceCountResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка
 */
export type GetDeviceCountResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос получения списка устройств
 */
export type GetDeviceListRequestDto = {
  /**
   * Фильтр
   */
  filter?: DeviceFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Пагинация
   */
  readonly paging: DevicePagingRequestDto
}>
/**
 * Ответ на запрос получения списка устройств
 */
export type GetDeviceListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Устройство
   */
  readonly data: DeviceResponseDto
  /**
   * Ошибка
   */
  readonly error: GetDeviceListResponseErrorDto
}>
/**
 * Ошибка запроса на получение списка устройств
 */
export type GetDeviceListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса на получение списка устройств
 */
export type GetDeviceListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос получения устройства
 */
export type GetDeviceLiteRequestDto = {
  /**
   * Идентификатор
   */
  id: number
}
/**
 * Ответ на запрос получения устройства
 */
export type GetDeviceLiteResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Устройство
   */
  readonly data: DeviceLiteResponseDto
}>
/**
 * Запрос получения устройства
 */
export type GetDeviceRequestDto = {
  /**
   * Идентификатор
   */
  id: number
}
/**
 * Ответ на запрос получения устройства
 */
export type GetDeviceResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Устройство
   */
  readonly data: DeviceResponseDto
}>
/**
 * Запрос на изменение статуса конфигурации устройства
 */
export type PostDeviceConfigurationStatusRequestDto = {
  /**
   * Статус конфигурации устройства
   */
  data: DeviceConfigurationStatusRequestDto
}
/**
 * Ответ на запрос на изменение статуса конфигурации устройства
 */
export type PostDeviceConfigurationStatusResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Статус конфигурации устройства
   */
  readonly data: DeviceConfigurationStatusResponseDto
  /**
   * Ошибка
   */
  readonly error: PostDeviceConfigurationStatusResponseErrorDto
}>
/**
 * Ошибка запроса сохранения статуса конфигурации устройства
 */
export type PostDeviceConfigurationStatusResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка запроса сохранения статуса конфигурации устройства
 */
export type PostDeviceConfigurationStatusResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос установки пресета на устройство
 */
export type PostDeviceInstallPresetRequestDto = {
  /**
   * Идентификатор
   */
  id: number
}
/**
 * Ответ на запрос установки пресета на устройство
 */
export type PostDeviceInstallPresetResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка при установке пресета
   */
  readonly error: PostDeviceInstallPresetResponseErrorDto
}>
/**
 * Ошибка при установке пресета
 */
export type PostDeviceInstallPresetResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Пресет в процессе установки
   */
  readonly presetStatusIsProcessing: PostDeviceInstallPresetResponseErrorPresetStatusIsProcessingRequestDto
}>
/**
 * Ошибка при установке пресета
 */
export type PostDeviceInstallPresetResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Пресет в процессе установки
   */
  readonly presetStatusIsProcessing: PostDeviceInstallPresetResponseErrorPresetStatusIsProcessingDto
}>
/**
 * Пресет в процессе установки
 */
export type PostDeviceInstallPresetResponseErrorPresetStatusIsProcessingRequestDto = {
}
/**
 * Пресет в процессе установки
 */
export type PostDeviceInstallPresetResponseErrorPresetStatusIsProcessingDto = {
}
/**
 * Запрос на переконфигурирование устройства
 */
export type PostDeviceReconfigureRequestDto = {
  /**
   * Идентификатор устройства
   */
  id: number
}
/**
 * Ответ на запрос на переконфигурирование устройства
 */
export type PostDeviceReconfigureResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка переконфигурирования устройства
   */
  readonly error: PostDeviceReconfigureResponseErrorDto
}>
/**
 * Ошибка переконфигурирования устройства
 */
export type PostDeviceReconfigureResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validationError: ValidationErrorRequestDto
  /**
   * Ошибка реинстала
   */
  readonly reinstallError: ReinstallErrorRequestDto
}>
/**
 * Ошибка переконфигурирования устройства
 */
export type PostDeviceReconfigureResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validationError: ValidationErrorResponseDto
  /**
   * Ошибка реинстала
   */
  readonly reinstallError: ReinstallErrorResponseDto
}>
/**
 * Запрос на замену устройства
 */
export type PostDeviceReplaceRequestDto = {
  /**
   * Идентификатор устройства
   */
  id: number
  /**
   * Хост
   */
  host?: string
  /**
   * MAC-адрес.
   * # Диапазон: 17..17.
   * # Паттерн: /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/
   */
  macAddress: string
  /**
   * Серийный номер
   */
  serialNumber: string
  /**
   * Логин (для модели спутник)
   */
  login?: string
}
/**
 * Ответ на запрос на замену устройства
 */
export type PostDeviceReplaceResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка замены устройства
   */
  readonly error: PostDeviceReplaceResponseErrorDto
}>
/**
 * Ошибка замены устройства
 */
export type PostDeviceReplaceResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validationError: ValidationErrorRequestDto
  /**
   * На платформе уже существует устройство с таким хостом
   */
  readonly hostExists: PostDeviceReplaceResponseErrorHostExistsRequestDto
  /**
   * На платформе уже существует устройство с таким MAC-адресом
   */
  readonly macAddressExists: PostDeviceReplaceResponseErrorMacAddressExistsRequestDto
  /**
   * На платформе уже существует устройство с таким серийным номером
   */
  readonly serialNumberExists: PostDeviceReplaceResponseErrorSerialNumberExistsRequestDto
  /**
   * На платформе уже существует устройство с таким логином (для устройст модели \"Спутник\")
   */
  readonly loginExists: PostDeviceReplaceResponseErrorLoginExistsRequestDto
  /**
   * Отсутствует поле Login для модели \"Спутник\"
   */
  readonly loginIsRequired: PostDeviceReplaceResponseErrorLoginIsRequiredRequestDto
  /**
   * Ошибка реинстала
   */
  readonly reinstallError: ReinstallErrorRequestDto
}>
/**
 * Ошибка замены устройства
 */
export type PostDeviceReplaceResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validationError: ValidationErrorResponseDto
  /**
   * На платформе уже существует устройство с таким хостом
   */
  readonly hostExists: PostDeviceReplaceResponseErrorHostExistsDto
  /**
   * На платформе уже существует устройство с таким MAC-адресом
   */
  readonly macAddressExists: PostDeviceReplaceResponseErrorMacAddressExistsDto
  /**
   * На платформе уже существует устройство с таким серийным номером
   */
  readonly serialNumberExists: PostDeviceReplaceResponseErrorSerialNumberExistsDto
  /**
   * На платформе уже существует устройство с таким логином (для устройст модели \"Спутник\")
   */
  readonly loginExists: PostDeviceReplaceResponseErrorLoginExistsDto
  /**
   * Отсутствует поле Login для модели \"Спутник\"
   */
  readonly loginIsRequired: PostDeviceReplaceResponseErrorLoginIsRequiredDto
  /**
   * Ошибка реинстала
   */
  readonly reinstallError: ReinstallErrorResponseDto
}>
/**
 * На платформе уже существует устройство с таким хостом
 */
export type PostDeviceReplaceResponseErrorHostExistsRequestDto = {
}
/**
 * На платформе уже существует устройство с таким хостом
 */
export type PostDeviceReplaceResponseErrorHostExistsDto = {
}
/**
 * На платформе уже существует устройство с таким логином (для устройст модели \"Спутник\")
 */
export type PostDeviceReplaceResponseErrorLoginExistsRequestDto = {
}
/**
 * На платформе уже существует устройство с таким логином (для устройст модели \"Спутник\")
 */
export type PostDeviceReplaceResponseErrorLoginExistsDto = {
}
/**
 * Отсутствует поле Login для модели \"Спутник\"
 */
export type PostDeviceReplaceResponseErrorLoginIsRequiredRequestDto = {
}
/**
 * Отсутствует поле Login для модели \"Спутник\"
 */
export type PostDeviceReplaceResponseErrorLoginIsRequiredDto = {
}
/**
 * На платформе уже существует устройство с таким MAC-адресом
 */
export type PostDeviceReplaceResponseErrorMacAddressExistsRequestDto = {
}
/**
 * На платформе уже существует устройство с таким MAC-адресом
 */
export type PostDeviceReplaceResponseErrorMacAddressExistsDto = {
}
/**
 * На платформе уже существует устройство с таким серийным номером
 */
export type PostDeviceReplaceResponseErrorSerialNumberExistsRequestDto = {
}
/**
 * На платформе уже существует устройство с таким серийным номером
 */
export type PostDeviceReplaceResponseErrorSerialNumberExistsDto = {
}
/**
 * Запрос на создание/изменение устройства
 */
export type PostDeviceRequestDto = {
  /**
   * Устройство
   */
  data: DeviceRequestDto
}
/**
 * Ответ на запрос на создание/изменение устройства
 */
export type PostDeviceResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Устройство
   */
  readonly data: DeviceResponseDto
  /**
   * Ошибка
   */
  readonly error: PostDeviceResponseErrorDto
}>
/**
 * Ошибка запроса сохранения устройства
 */
export type PostDeviceResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
  /**
   * Ошибка сохранения
   */
  readonly saving: DeviceSavingErrorRequestDto
}>
/**
 * Ошибка запроса сохранения устройства
 */
export type PostDeviceResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
  /**
   * Ошибка сохранения
   */
  readonly saving: DeviceSavingErrorResponseDto
}>
/**
 * Пресет.
 * Пресет с id=1 устанавливается при создании устройства по умолчанию
 */
export type PresetRequestDto = {
  /**
   * Идентификатор.
   * # Диапазон: 1..2147483647
   */
  id?: number
  /**
   * Наименование.
   * # Диапазон: 3..256
   */
  title: string
  /**
   * Идентификатор МРФ.
   * # Диапазон: 0..10
   */
  mrfIds: number[]
  /**
   * Идентификатор РФ.
   * # Диапазон: 0..100
   */
  rfIds: number[]
  /**
   * Описание.
   * # Диапазон: 3..1024
   */
  description?: string | null
  /**
   * Статус
   */
  statusType: PresetStatusTypeRequestEnum
  /**
   * Параметр SIP
   */
  sip: PresetSipRequestDto
  /**
   * Параметр NTP
   */
  ntp: PresetNtpRequestDto
  /**
   * Параметр Syslog
   */
  syslog: PresetSyslogRequestDto
  /**
   * Помещения.
   * # Диапазон: 0..10000
   */
  rooms: PresetRoomRequestDto[]
  /**
   * Параметры конфигурации видео
   */
  videoConfig: PresetVideoConfigRequestDto
  /**
   * Параметр DTMF.
   * # Диапазон: 0..64
   */
  dtmf: PresetDtmfRequestDto[]
  /**
   * Распознование лиц
   */
  faceRecognition?: PresetFaceRecognitionRequestDto | null
}
/**
 * Пресет.
 * Пресет с id=1 устанавливается при создании устройства по умолчанию
 */
export type PresetResponseDto = {
  /**
   * Идентификатор.
   * # Диапазон: 1..2147483647
   */
  id: number
  /**
   * Наименование.
   * # Диапазон: 3..256
   */
  title: string
  /**
   * Идентификатор МРФ.
   * # Диапазон: 0..10
   */
  mrfIds: number[]
  /**
   * Идентификатор РФ.
   * # Диапазон: 0..100
   */
  rfIds: number[]
  /**
   * Описание.
   * # Диапазон: 3..1024
   */
  description: string | null
  /**
   * Дата и время создания.
   * # Тип: DateTime
   */
  readonly createdAt: string
  /**
   * Дата последнего изменения.
   * Заполняется и обновляется сервером.
   * Заполняется при создании и изменении.
   * Является версией объекта.
   * # Тип: DateTime
   */
  readonly changedAt: string
  /**
   * Статус
   */
  statusType: PresetStatusTypeResponseEnum
  /**
   * Параметр SIP
   */
  sip: PresetSipResponseDto
  /**
   * Параметр NTP
   */
  ntp: PresetNtpResponseDto
  /**
   * Параметр Syslog
   */
  syslog: PresetSyslogResponseDto
  /**
   * Помещения.
   * # Диапазон: 0..10000
   */
  rooms: PresetRoomResponseDto[]
  /**
   * Параметры конфигурации видео
   */
  videoConfig: PresetVideoConfigResponseDto
  /**
   * Параметр DTMF.
   * # Диапазон: 0..64
   */
  dtmf: PresetDtmfResponseDto[]
  /**
   * Распознование лиц
   */
  faceRecognition: PresetFaceRecognitionResponseDto | null
}
/**
 * Параметр DTMF
 */
export type PresetDtmfRequestDto = {
  /**
   * Код.
   * # Диапазон: 1..1
   */
  code: string
  /**
   * Индекс реле.
   * # Диапазон: 0..64
   */
  relayIndex?: number
}
/**
 * Параметр DTMF
 */
export type PresetDtmfResponseDto = {
  /**
   * Код.
   * # Диапазон: 1..1
   */
  code: string
  /**
   * Индекс реле.
   * # Диапазон: 0..64
   */
  relayIndex: number
}
/**
 * Распознование лиц
 */
export type PresetFaceRecognitionRequestDto = {
  /**
   * Адрес
   */
  host: string
  /**
   * Альтернативный адрес
   */
  altHost?: string
  /**
   * Путь запроса к серверу
   */
  endpoint: string
  /**
   * Токен
   */
  authToken: string
  /**
   * Тип конфигурации
   */
  configurationType: PresetFaceRecognitionConfigurationTypeRequestEnum
  /**
   * Идентификатор источника в identix
   */
  originId: string
  /**
   * Идентификаторы групп профилей в identix
   */
  groupIds?: number[]
}
/**
 * Распознование лиц
 */
export type PresetFaceRecognitionResponseDto = {
  /**
   * Адрес
   */
  host: string
  /**
   * Альтернативный адрес
   */
  altHost: string
  /**
   * Путь запроса к серверу
   */
  endpoint: string
  /**
   * Токен
   */
  authToken: string
  /**
   * Тип конфигурации
   */
  configurationType: PresetFaceRecognitionConfigurationTypeResponseEnum
  /**
   * Идентификатор источника в identix
   */
  originId: string
  /**
   * Идентификаторы групп профилей в identix
   */
  groupIds: number[]
}
/**
 * Параметр NTP
 */
export type PresetNtpRequestDto = {
  /**
   * Хост.
   * # Диапазон: 5..256
   */
  host: string
  /**
   * Порт.
   * # Диапазон: 1..65536
   */
  port: number
}
/**
 * Параметр NTP
 */
export type PresetNtpResponseDto = {
  /**
   * Хост.
   * # Диапазон: 5..256
   */
  host: string
  /**
   * Порт.
   * # Диапазон: 1..65536
   */
  port: number
}
/**
 * Помещение
 */
export type PresetRoomRequestDto = {
  /**
   * Номер телефона.
   * # Диапазон: 5..14
   */
  phone: string
  /**
   * Номер помещения.
   * # Диапазон: 1..10000
   */
  num: number
}
/**
 * Помещение
 */
export type PresetRoomResponseDto = {
  /**
   * Номер телефона.
   * # Диапазон: 5..14
   */
  phone: string
  /**
   * Номер помещения.
   * # Диапазон: 1..10000
   */
  num: number
}
/**
 * Ошибка сохранения.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type PresetSavingErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Конфликт версий
   */
  readonly conflict: PresetSavingErrorConflictRequestDto
  /**
   * Запрещено для дефолтного пресета
   */
  readonly notAllowedForDefault: PresetSavingErrorNotAllowedForDefaultRequestDto
}>
/**
 * Ошибка сохранения.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type PresetSavingErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Конфликт версий
   */
  readonly conflict: PresetSavingErrorConflictResponseDto
  /**
   * Запрещено для дефолтного пресета
   */
  readonly notAllowedForDefault: PresetSavingErrorNotAllowedForDefaultResponseDto
}>
/**
 * Конфликт версий.
 * Причины:
 * - В базе хранится другая версия строки, значения changed_at отличаются
 */
export type PresetSavingErrorConflictRequestDto = {
}
/**
 * Конфликт версий.
 * Причины:
 * - В базе хранится другая версия строки, значения changed_at отличаются
 */
export type PresetSavingErrorConflictResponseDto = {
}
/**
 * Недоступно для дефолтного пресета.
 * Причины:
 * - Смена статуса на Архивный
 */
export type PresetSavingErrorNotAllowedForDefaultRequestDto = {
}
/**
 * Недоступно для дефолтного пресета.
 * Причины:
 * - Смена статуса на Архивный
 */
export type PresetSavingErrorNotAllowedForDefaultResponseDto = {
}
/**
 * Параметр SIP
 */
export type PresetSipRequestDto = {
  /**
   * Хост.
   * # Диапазон: 5..256
   */
  host: string
  /**
   * Порт.
   * # Диапазон: 1..65536
   */
  port: number
  /**
   * Хост reg.
   * # Диапазон: 5..256
   */
  regHost: string
  /**
   * Порт reg.
   * # Диапазон: 1..65536
   */
  regPort: number
  /**
   * Хост proxy.
   * # Диапазон: 5..256
   */
  proxyHost: string
  /**
   * Порт proxy.
   * # Диапазон: 1..65536
   */
  proxyPort: number
}
/**
 * Параметр SIP
 */
export type PresetSipResponseDto = {
  /**
   * Хост.
   * # Диапазон: 5..256
   */
  host: string
  /**
   * Порт.
   * # Диапазон: 1..65536
   */
  port: number
  /**
   * Хост reg.
   * # Диапазон: 5..256
   */
  regHost: string
  /**
   * Порт reg.
   * # Диапазон: 1..65536
   */
  regPort: number
  /**
   * Хост proxy.
   * # Диапазон: 5..256
   */
  proxyHost: string
  /**
   * Порт proxy.
   * # Диапазон: 1..65536
   */
  proxyPort: number
}
/**
 * Параметр Syslog
 */
export type PresetSyslogRequestDto = {
  /**
   * Хост.
   * # Диапазон: 5..256
   */
  host: string
  /**
   * Порт.
   * # Диапазон: 1..65536
   */
  port: number
  /**
   * Протокол
   */
  protocolType: PresetSyslogProtocolTypeRequestEnum
}
/**
 * Параметр Syslog
 */
export type PresetSyslogResponseDto = {
  /**
   * Хост.
   * # Диапазон: 5..256
   */
  host: string
  /**
   * Порт.
   * # Диапазон: 1..65536
   */
  port: number
  /**
   * Протокол
   */
  protocolType: PresetSyslogProtocolTypeResponseEnum
}
/**
 * Параметры конфигурации видео
 */
export type PresetVideoConfigRequestDto = {
  /**
   * Тип пресета
   */
  qualityType: PresetVideoConfigQualityTypeRequestEnum
  /**
   * Пользователь
   */
  rtspUser: PresetVideoConfigRtspUserRequestDto
}
/**
 * Параметры конфигурации видео
 */
export type PresetVideoConfigResponseDto = {
  /**
   * Тип пресета
   */
  qualityType: PresetVideoConfigQualityTypeResponseEnum
  /**
   * Пользователь
   */
  rtspUser: PresetVideoConfigRtspUserResponseDto
}
/**
 * Пользователь
 */
export type PresetVideoConfigRtspUserRequestDto = {
  /**
   * Имя пользователя.
   * # Диапазон: 3..256
   */
  username: string
  /**
   * Пароль.
   * # Диапазон: 3..256
   */
  password: string
}
/**
 * Пользователь
 */
export type PresetVideoConfigRtspUserResponseDto = {
  /**
   * Имя пользователя.
   * # Диапазон: 3..256
   */
  username: string
  /**
   * Пароль.
   * # Диапазон: 3..256
   */
  password: string
}
/**
 * Запрос изменения устройства
 */
export type PutDeviceRequestDto = {
  /**
   * Идентификатор устройства
   */
  id: number
  /**
   * Идентификатор пресета
   */
  presetId?: number
  /**
   * Настройка режима SL3
   */
  isSl3ModeEnabled?: boolean
}
/**
 * ответ на завпрос изменения устройства
 */
export type PutDeviceResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Устройство
   */
  readonly data: DeviceResponseDto
}>
/**
 * Ошибки реинстала
 */
export type ReinstallErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Сип-логин отсутствует на устройстве
   */
  readonly sipLoginIsMissing: ReinstallErrorSipLoginIsMissingRequestDto
}>
/**
 * Ошибки реинстала
 */
export type ReinstallErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Сип-логин отсутствует на устройстве
   */
  readonly sipLoginIsMissing: ReinstallErrorSipLoginIsMissingResponseDto
}>
/**
 * Сип-логин отсутствует на устройстве
 */
export type ReinstallErrorSipLoginIsMissingRequestDto = {
}
/**
 * Сип-логин отсутствует на устройстве
 */
export type ReinstallErrorSipLoginIsMissingResponseDto = {
}
/**
 * Статус синхронизации.
 * # Описание модели
 */
export type SyncStatusRequestDto = {
}
/**
 * Статус синхронизации.
 * # Описание модели
 */
export type SyncStatusResponseDto = {
  /**
   * Статус синхронизации
   */
  readonly statusType: SyncStatusStatusTypeResponseEnum
  /**
   * Сообщение об ошибке
   */
  readonly errorMessage: string
  /**
   * Количество попыток
   */
  readonly retryCount: number
  /**
   * Дата последней успешной синхронизации.
   * # Тип: DateTime
   */
  readonly successfulAt: string | null
  /**
   * Дата последней синхронизации.
   * # Тип: DateTime
   */
  readonly syncAt: string | null
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type ValidationErrorRequestDto = {
  /**
   * Путь к полю в формате наименования прото
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type ValidationErrorResponseDto = {
  /**
   * Путь к полю в формате наименования прото
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Статус камеры.
   * # Описание модели
   */
  "CameraStatus": {
    "kind": "class",
    "text": "Статус камеры.\n# Описание модели",
    "fields": {
      /**
       * Идентификатор камеры uid.
       * # Тип: Guid
       */
      "id": {
        "type": "google.protobuf.StringValue",
        "text": "Идентификатор камеры uid.\n# Тип: Guid",
      },
      /**
       * Статус камеры
       */
      "statusType": {
        "type": "CameraStatus.StatusType",
        "text": "Статус камеры",
      },
      /**
       * Сообщение об ошибке
       */
      "errorMessage": {
        "type": "string",
        "text": "Сообщение об ошибке",
      },
    },
  },
  /**
   * Запрос удаления устройства
   */
  "DeleteDeviceRequest": {
    "kind": "class",
    "text": "Запрос удаления устройства",
    "fields": {
      /**
       * Идентификатор устройства
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления устройства
   */
  "DeleteDeviceResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления устройства",
  },
  /**
   * Устройство.
   * # Описание модели
   */
  "Device": {
    "kind": "class",
    "text": "Устройство.\n# Описание модели",
    "fields": {
      /**
       * Идентификатор.
       * # Диапазон: 0..2147483647
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
      /**
       * Идентификатор пресета.
       * # Диапазон: 1..2147483647
       */
      "presetId": {
        "type": "int32",
        "text": "Идентификатор пресета.\n# Диапазон: 1..2147483647",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
      /**
       * Статус установки пресета.
       * # Поле вычисляется в коде приложения
       * @deprecated
       */
      "presetStatusType": {
        "type": "Device.PresetStatusType",
        "text": "Статус установки пресета.\n# Поле вычисляется в коде приложения",
      },
      /**
       * Дата установки пресета на устройство.
       * # Тип: DateTime
       * @deprecated
       */
      "presetConfiguredAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата установки пресета на устройство.\n# Тип: DateTime",
      },
      /**
       * Настройка режима SL3
       * @deprecated
       */
      "isSl3ModeEnabled": {
        "type": "bool",
        "text": "Настройка режима SL3",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип назначения устройства
       */
      "type": {
        "type": "Device.Type",
        "text": "Тип назначения устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * MAC-адрес.
       * # Диапазон: 17..17.
       * # Паттерн: /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/
       */
      "macAddress": {
        "type": "string",
        "text": "MAC-адрес.\n# Диапазон: 17..17.\n# Паттерн: /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 17,
            "message": "Значение не входит в допустимый диапазон. Минимум: 17"
          },
          "maxLength": {
            "value": 17,
            "message": "Значение не входит в допустимый диапазон. Максимум: 17"
          },
          "pattern": {
            "value": /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/,
            "message": "Значение не соответствует регулярному выражению. Паттерн: /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/"
          }
        }
      },
      /**
       * Наименование устройства.
       * # Диапазон: 3..256
       */
      "title": {
        "type": "string",
        "text": "Наименование устройства.\n# Диапазон: 3..256",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
      /**
       * Модель устройства
       */
      "modelType": {
        "type": "Device.ModelType",
        "text": "Модель устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор компании владельца.
       * # Диапазон: 1..2147483647
       */
      "ownerCompanyId": {
        "type": "int32",
        "text": "Идентификатор компании владельца.\n# Диапазон: 1..2147483647",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
      /**
       * Серийный номер.
       * # Диапазон: 1..16
       */
      "serialNumber": {
        "type": "string",
        "text": "Серийный номер.\n# Диапазон: 1..16",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "maxLength": {
            "value": 16,
            "message": "Значение не входит в допустимый диапазон. Максимум: 16"
          },
        }
      },
      /**
       * Идентификатор квартирограммы.
       * # Диапазон: 1..2147483647
       */
      "flatgrammId": {
        "type": "int32",
        "text": "Идентификатор квартирограммы.\n# Диапазон: 1..2147483647",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
      /**
       * Смещение таймзоны в минутах.
       * # Диапазон: -720..840
       */
      "utcOffset": {
        "type": "int32",
        "text": "Смещение таймзоны в минутах.\n# Диапазон: -720..840",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": -720,
            "message": "Значение не входит в допустимый диапазон. Минимум: -720"
          },
          "max": {
            "value": 840,
            "message": "Значение не входит в допустимый диапазон. Максимум: 840"
          },
        }
      },
      /**
       * Статус устройства
       */
      "statusType": {
        "type": "Device.StatusType",
        "text": "Статус устройства",
      },
      /**
       * Сетевой адрес.
       * # Диапазон: 0..250
       */
      "ipAddress": {
        "type": "google.protobuf.StringValue",
        "text": "Сетевой адрес.\n# Диапазон: 0..250",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 250,
            "message": "Значение не входит в допустимый диапазон. Максимум: 250"
          },
        }
      },
      /**
       * Сетевой порт.
       * # Диапазон: 0..65535
       */
      "port": {
        "type": "google.protobuf.Int32Value",
        "text": "Сетевой порт.\n# Диапазон: 0..65535",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 65535,
            "message": "Значение не входит в допустимый диапазон. Максимум: 65535"
          },
        }
      },
      /**
       * Учетные данные.
       * Используется для устройств с типом модели SPUTNIK_IO
       */
      "sputnikCredentials": {
        "type": "Device.SputnikCredentials",
        "text": "Учетные данные.\nИспользуется для устройств с типом модели SPUTNIK_IO",
      },
      /**
       * Координаты
       */
      "location": {
        "type": "Device.Location",
        "text": "Координаты",
      },
      /**
       * Идентификатор камеры uid.
       * # Тип: Guid
       */
      "cameraId": {
        "type": "google.protobuf.StringValue",
        "text": "Идентификатор камеры uid.\n# Тип: Guid",
      },
      /**
       * Список тегов устройства.
       * # Диапазон: 1..50
       */
      "tags": {
        "type": "string",
        "text": "Список тегов устройства.\n# Диапазон: 1..50",
        "rules": {
          "minLength": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "maxLength": {
            "value": 50,
            "message": "Значение не входит в допустимый диапазон. Максимум: 50"
          },
        }
      },
      /**
       * Настройки устройства
       */
      "settings": {
        "type": "Device.Settings",
        "text": "Настройки устройства",
      },
      /**
       * Версия аппаратного обеспенения
       */
      "hardwareVersion": {
        "type": "string",
        "text": "Версия аппаратного обеспенения",
      },
      /**
       * Версия программного обеспенения
       */
      "softwareVersion": {
        "type": "string",
        "text": "Версия программного обеспенения",
      },
      /**
       * Диспетчеризации
       */
      "dispatching": {
        "type": "Device.Dispatching",
        "text": "Диспетчеризации",
      },
      /**
       * Транк
       */
      "sipTrunk": {
        "type": "Device.SipTrunk",
        "text": "Транк",
      },
      /**
       * Переадресация
       */
      "redirect": {
        "type": "Device.Redirect",
        "text": "Переадресация",
      },
      /**
       * Настройки автозамены пароля
       */
      "autochangePasswordSettings": {
        "type": "Device.AutochangePasswordSettings",
        "text": "Настройки автозамены пароля",
      },
      /**
       * Учетные данные пользователей
       */
      "credentials": {
        "type": "Device.Credentials",
        "text": "Учетные данные пользователей",
      },
      /**
       * Сип-аккаунт
       */
      "sipAccount": {
        "type": "google.protobuf.StringValue",
        "text": "Сип-аккаунт",
      },
      /**
       * Статус синхронизации
       */
      "syncStatus": {
        "type": "SyncStatus",
        "text": "Статус синхронизации",
      },
    },
  },
  /**
   * Настройки автозамены пароля
   */
  "Device.AutochangePasswordSettings": {
    "kind": "class",
    "text": "Настройки автозамены пароля",
    "fields": {
      /**
       * Статус настройки автозамены пароля
       */
      "isEnabled": {
        "type": "bool",
        "text": "Статус настройки автозамены пароля",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Учетные данные пользователей
   */
  "Device.Credentials": {
    "kind": "class",
    "text": "Учетные данные пользователей",
    "fields": {
      /**
       * Логин.
       * # Диапазон: 0..100
       */
      "login": {
        "type": "google.protobuf.StringValue",
        "text": "Логин.\n# Диапазон: 0..100",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Пароль.
       * # Диапазон: 0..100
       */
      "password": {
        "type": "google.protobuf.StringValue",
        "text": "Пароль.\n# Диапазон: 0..100",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Тип доступа пользователя
       */
      "userAccessType": {
        "type": "Device.Credentials.UserAccessType",
        "text": "Тип доступа пользователя",
      },
    },
  },
  /**
   * Диспетчеризации
   */
  "Device.Dispatching": {
    "kind": "class",
    "text": "Диспетчеризации",
    "fields": {
      /**
       * Статус настройки диспетчеризации
       */
      "isEnabled": {
        "type": "bool",
        "text": "Статус настройки диспетчеризации",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Публичный номер.
       * # Паттерн: /^[1-9]\d{3,7}$/
       */
      "publicIdentity": {
        "type": "google.protobuf.StringValue",
        "text": "Публичный номер.\n# Паттерн: /^[1-9]\d{3,7}$/",
        "rules": {
          "pattern": {
            "value": /^[1-9]\d{3,7}$/,
            "message": "Значение не соответствует регулярному выражению. Паттерн: /^[1-9]\d{3,7}$/"
          }
        }
      },
    },
  },
  /**
   * Координаты
   */
  "Device.Location": {
    "kind": "class",
    "text": "Координаты",
    "fields": {
      /**
       * Широта
       */
      "latitude": {
        "type": "float",
        "text": "Широта",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Долгота
       */
      "longitude": {
        "type": "float",
        "text": "Долгота",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Переадресация.
   * Требуется капабилити SIP_CALLS
   */
  "Device.Redirect": {
    "kind": "class",
    "text": "Переадресация.\nТребуется капабилити SIP_CALLS",
    "fields": {
      /**
       * Переадресация на SIP
       */
      "isEnabledSip": {
        "type": "bool",
        "text": "Переадресация на SIP",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Переадресация на телефон
       */
      "isEnabledPhone": {
        "type": "bool",
        "text": "Переадресация на телефон",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ошибка сохранения.
   * Эти проверки выполняются при работе с базой данных и сторонними сервисами
   */
  "Device.SavingError": {
    "kind": "class",
    "text": "Ошибка сохранения.\nЭти проверки выполняются при работе с базой данных и сторонними сервисами",
    "fields": {
      /**
       * Переданный мак-адрес не валидный
       * @deprecated
       */
      "macAddressInvalid": {
        "type": "Device.SavingError.MacAddressInvalid",
        "text": "Переданный мак-адрес не валидный",
      },
      /**
       * Переданный серийный номер не валидный
       * @deprecated
       */
      "serialNumberInvalid": {
        "type": "Device.SavingError.SerialNumberInvalid",
        "text": "Переданный серийный номер не валидный",
      },
      /**
       * Нельзя изменить тип назначения девайса
       */
      "notAllowedForType": {
        "type": "Device.SavingError.NotAllowedForType",
        "text": "Нельзя изменить тип назначения девайса",
      },
      /**
       * Нельзя изменить модель девайса
       */
      "notAllowedForModel": {
        "type": "Device.SavingError.NotAllowedForModel",
        "text": "Нельзя изменить модель девайса",
      },
      /**
       * Серийный номер для данной модели уже существует на платформе
       */
      "serialNumberForModelIsExist": {
        "type": "Device.SavingError.SerialNumberForModelIsExist",
        "text": "Серийный номер для данной модели уже существует на платформе",
      },
      /**
       * MAC-адрес уже существует на платформе
       */
      "macAddressIsExist": {
        "type": "Device.SavingError.MacAddressIsExist",
        "text": "MAC-адрес уже существует на платформе",
      },
      /**
       * Настройка не поддерживается
       */
      "capabilityIsNotSupported": {
        "type": "Device.SavingError.CapabilityIsNotSupported",
        "text": "Настройка не поддерживается",
      },
      /**
       * ABC-номер присвоен другому устройству
       */
      "abcNumberIsExistOnAnotherDevice": {
        "type": "Device.SavingError.AbcNumberIsExistOnAnotherDevice",
        "text": "ABC-номер присвоен другому устройству",
      },
      /**
       * Публичный номер уже существует на платформе
       */
      "publicIdentityIsExist": {
        "type": "Device.SavingError.PublicIdentityIsExist",
        "text": "Публичный номер уже существует на платформе",
      },
      /**
       * Не найдена квартира для консьержа
       */
      "conciergeRoomNotFound": {
        "type": "Device.SavingError.ConciergeRoomNotFound",
        "text": "Не найдена квартира для консьержа",
      },
      /**
       * Логин уже существует на платформе
       */
      "loginIsExist": {
        "type": "Device.SavingError.LoginIsExist",
        "text": "Логин уже существует на платформе",
      },
      /**
       * Отсутствуют реквизиты для модели \"Спутник\"
       */
      "credentialsAreRequired": {
        "type": "Device.SavingError.CredentialsAreRequired",
        "text": "Отсутствуют реквизиты для модели \"Спутник\"",
      },
      /**
       * Переданное поле не поддерживается
       */
      "fieldIsNotSupported": {
        "type": "Device.SavingError.FieldIsNotSupported",
        "text": "Переданное поле не поддерживается",
      },
    },
  },
  /**
   * ABC-номер присвоен другому устройству
   */
  "Device.SavingError.AbcNumberIsExistOnAnotherDevice": {
    "kind": "class",
    "text": "ABC-номер присвоен другому устройству",
    "fields": {
      /**
       * Идентификатор устройства на котором находится ABC-номер
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства на котором находится ABC-номер",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Функциональность не поддерживается моделью устройства
   */
  "Device.SavingError.CapabilityIsNotSupported": {
    "kind": "class",
    "text": "Функциональность не поддерживается моделью устройства",
    "fields": {
      /**
       * Возможность
       */
      "modelCapabilityType": {
        "type": "Model.CapabilityType",
        "text": "Возможность",
      },
    },
  },
  /**
   * Не найдена квартира для консьержа
   */
  "Device.SavingError.ConciergeRoomNotFound": {
    "kind": "class",
    "text": "Не найдена квартира для консьержа",
  },
  /**
   * Отсутствуют реквизиты для модели \"Спутник\"
   */
  "Device.SavingError.CredentialsAreRequired": {
    "kind": "class",
    "text": "Отсутствуют реквизиты для модели \"Спутник\"",
  },
  /**
   * Переданное поле не поддерживается
   */
  "Device.SavingError.FieldIsNotSupported": {
    "kind": "class",
    "text": "Переданное поле не поддерживается",
  },
  /**
   * Логин уже существует на платформе
   */
  "Device.SavingError.LoginIsExist": {
    "kind": "class",
    "text": "Логин уже существует на платформе",
  },
  /**
   * Переданный мак-адрес не валидный
   */
  "Device.SavingError.MacAddressInvalid": {
    "kind": "class",
    "text": "Переданный мак-адрес не валидный",
  },
  /**
   * MAC-адрес уже существует на платформе
   */
  "Device.SavingError.MacAddressIsExist": {
    "kind": "class",
    "text": "MAC-адрес уже существует на платформе",
  },
  /**
   * Нельзя изменить модель девайса
   */
  "Device.SavingError.NotAllowedForModel": {
    "kind": "class",
    "text": "Нельзя изменить модель девайса",
  },
  /**
   * Нельзя изменить тип назначения девайса
   */
  "Device.SavingError.NotAllowedForType": {
    "kind": "class",
    "text": "Нельзя изменить тип назначения девайса",
  },
  /**
   * Публичный номер уже существует на платформе
   */
  "Device.SavingError.PublicIdentityIsExist": {
    "kind": "class",
    "text": "Публичный номер уже существует на платформе",
  },
  /**
   * Серийный номер для данной модели уже существует на платформе
   */
  "Device.SavingError.SerialNumberForModelIsExist": {
    "kind": "class",
    "text": "Серийный номер для данной модели уже существует на платформе",
  },
  /**
   * Переданный серийный номер не валидный
   */
  "Device.SavingError.SerialNumberInvalid": {
    "kind": "class",
    "text": "Переданный серийный номер не валидный",
  },
  /**
   * Настройки устройства
   */
  "Device.Settings": {
    "kind": "class",
    "text": "Настройки устройства",
    "fields": {
      /**
       * Настройки ККМ
       */
      "coordinateMatrixSwitch": {
        "type": "Device.Settings.CoordinateMatrixSwitch",
        "text": "Настройки ККМ",
      },
      /**
       * Настройки вызова консьержа.
       * Требуется капабилити CONCIERGE_CALL
       */
      "conciergeCall": {
        "type": "Device.Settings.ConciergeCall",
        "text": "Настройки вызова консьержа.\nТребуется капабилити CONCIERGE_CALL",
      },
      /**
       * Настройки автосбора
       */
      "autocollect": {
        "type": "Device.Settings.Autocollect",
        "text": "Настройки автосбора",
      },
      /**
       * Настройки распознования лиц
       */
      "faceRecognition": {
        "type": "Device.Settings.FaceRecognition",
        "text": "Настройки распознования лиц",
      },
      /**
       * Настройки режима SL3
       */
      "sl3Mode": {
        "type": "Device.Settings.Sl3Mode",
        "text": "Настройки режима SL3",
      },
      /**
       * Настройки вызова экстренной службы.
       * Только для устройств с CapabilityType=EMERGENCY_CALL
       */
      "emergencyCall": {
        "type": "Device.Settings.EmergencyCall",
        "text": "Настройки вызова экстренной службы.\nТолько для устройств с CapabilityType=EMERGENCY_CALL",
      },
    },
  },
  /**
   * Настройки автосбора
   */
  "Device.Settings.Autocollect": {
    "kind": "class",
    "text": "Настройки автосбора",
    "fields": {
      /**
       * Статус настройки автосбора
       */
      "isEnabled": {
        "type": "bool",
        "text": "Статус настройки автосбора",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Настройки вызова консьержа
   */
  "Device.Settings.ConciergeCall": {
    "kind": "class",
    "text": "Настройки вызова консьержа",
    "fields": {
      /**
       * Статус настройки вызова консьержа
       */
      "isEnabled": {
        "type": "bool",
        "text": "Статус настройки вызова консьержа",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор ОРПОН
       */
      "orpon": {
        "type": "int64",
        "text": "Идентификатор ОРПОН",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер квартиры.
       * # Диапазон: 1..5
       */
      "roomNumber": {
        "type": "string",
        "text": "Номер квартиры.\n# Диапазон: 1..5",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "maxLength": {
            "value": 5,
            "message": "Значение не входит в допустимый диапазон. Максимум: 5"
          },
        }
      },
      /**
       * Номер сип-трубки
       */
      "sipNumber": {
        "type": "string",
        "text": "Номер сип-трубки",
      },
    },
  },
  /**
   * Настройки ККМ.
   * Коммутатор координатно-матричный (устройство для подключения аналоговых трубок к домофону)
   */
  "Device.Settings.CoordinateMatrixSwitch": {
    "kind": "class",
    "text": "Настройки ККМ.\nКоммутатор координатно-матричный (устройство для подключения аналоговых трубок к домофону)",
    "fields": {
      /**
       * Состояние
       */
      "isEnabled": {
        "type": "bool",
        "text": "Состояние",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Настройки вызова экстренной службы.
   * Только для устройств с CapabilityType=EMERGENCY_CALL
   */
  "Device.Settings.EmergencyCall": {
    "kind": "class",
    "text": "Настройки вызова экстренной службы.\nТолько для устройств с CapabilityType=EMERGENCY_CALL",
    "fields": {
      /**
       * Возможность вызова экстренной службы
       */
      "isCallAvailable": {
        "type": "bool",
        "text": "Возможность вызова экстренной службы",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * АБС-номер экстренной службы.
       * # Паттерн: /^\+[1-9][0-9]{10}$/
       */
      "emergencyNumber": {
        "type": "string",
        "text": "АБС-номер экстренной службы.\n# Паттерн: /^\+[1-9][0-9]{10}$/",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "pattern": {
            "value": /^\+[1-9][0-9]{10}$/,
            "message": "Значение не соответствует регулярному выражению. Паттерн: /^\+[1-9][0-9]{10}$/"
          }
        }
      },
    },
  },
  /**
   * Настройки распознования лиц
   */
  "Device.Settings.FaceRecognition": {
    "kind": "class",
    "text": "Настройки распознования лиц",
    "fields": {
      /**
       * Статус настройки
       */
      "isEnabled": {
        "type": "bool",
        "text": "Статус настройки",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Настройки режима SL3
   */
  "Device.Settings.Sl3Mode": {
    "kind": "class",
    "text": "Настройки режима SL3",
    "fields": {
      /**
       * Статус настройки
       */
      "isEnabled": {
        "type": "bool",
        "text": "Статус настройки",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор профиля шифрования
       */
      "encryptionProfileId": {
        "type": "google.protobuf.StringValue",
        "text": "Идентификатор профиля шифрования",
      },
    },
  },
  /**
   * Транк.
   * Параметры для соединения между устрйоством и телефонной сетью общего пользования.
   * Требуется капабилити SIP_CALLS
   */
  "Device.SipTrunk": {
    "kind": "class",
    "text": "Транк.\nПараметры для соединения между устрйоством и телефонной сетью общего пользования.\nТребуется капабилити SIP_CALLS",
    "fields": {
      /**
       * ABC-номер.
       * # Паттерн: /^(\+7)(\d{10})$/
       */
      "abcNumber": {
        "type": "string",
        "text": "ABC-номер.\n# Паттерн: /^(\+7)(\d{10})$/",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "pattern": {
            "value": /^(\+7)(\d{10})$/,
            "message": "Значение не соответствует регулярному выражению. Паттерн: /^(\+7)(\d{10})$/"
          }
        }
      },
      /**
       * Хост.
       * # Диапазон: 0..250
       */
      "host": {
        "type": "google.protobuf.StringValue",
        "text": "Хост.\n# Диапазон: 0..250",
        "rules": {
          "minLength": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "maxLength": {
            "value": 250,
            "message": "Значение не входит в допустимый диапазон. Максимум: 250"
          },
        }
      },
      /**
       * Порт.
       * # Диапазон: 0..65535
       */
      "port": {
        "type": "google.protobuf.Int32Value",
        "text": "Порт.\n# Диапазон: 0..65535",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 65535,
            "message": "Значение не входит в допустимый диапазон. Максимум: 65535"
          },
        }
      },
      /**
       * Тип сети связи
       */
      "sipType": {
        "type": "Device.SipTrunk.SipType",
        "text": "Тип сети связи",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Учетные данные.
   * Используется для устройств с типом модели SPUTNIK_IO
   */
  "Device.SputnikCredentials": {
    "kind": "class",
    "text": "Учетные данные.\nИспользуется для устройств с типом модели SPUTNIK_IO",
    "fields": {
      /**
       * Логин.
       * # Тип: Guid
       */
      "login": {
        "type": "string",
        "text": "Логин.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Пароль.
       * На чтение выводится только для пользователя с типом service
       */
      "password": {
        "type": "google.protobuf.StringValue",
        "text": "Пароль.\nНа чтение выводится только для пользователя с типом service",
      },
    },
  },
  /**
   * Статус конфигурации устройства.
   * # Описание модели
   */
  "DeviceConfigurationStatus": {
    "kind": "class",
    "text": "Статус конфигурации устройства.\n# Описание модели",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор",
      },
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип конфигурации
       */
      "configurationType": {
        "type": "DeviceConfigurationStatus.ConfigurationType",
        "text": "Тип конфигурации",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Статус конфигурации настройки устройства
       */
      "statusType": {
        "type": "DeviceConfigurationStatus.StatusType",
        "text": "Статус конфигурации настройки устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Дата последней конфигурации устройства.
       * # Тип: DateTime
       */
      "configuredAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата последней конфигурации устройства.\n# Тип: DateTime",
      },
      /**
       * Текст ошибки
       */
      "errorMessage": {
        "type": "google.protobuf.StringValue",
        "text": "Текст ошибки",
      },
      /**
       * Количество попыток
       */
      "retryCount": {
        "type": "int32",
        "text": "Количество попыток",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Дополнительная полезная нагрузка
       */
      "payload": {
        "type": "DeviceConfigurationStatus.Payload",
        "text": "Дополнительная полезная нагрузка",
      },
      /**
       * Минимально возможная дата выполнения следующей попытки.
       * # Тип: DateTime
       */
      "nextRetryAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Минимально возможная дата выполнения следующей попытки.\n# Тип: DateTime",
      },
    },
  },
  /**
   * Дополнительная полезная нагрузка
   */
  "DeviceConfigurationStatus.Payload": {
    "kind": "class",
    "text": "Дополнительная полезная нагрузка",
    "fields": {
      /**
       * Автоколлект
       */
      "autocollect": {
        "type": "DeviceConfigurationStatus.Payload.Autocollect",
        "text": "Автоколлект",
      },
    },
  },
  /**
   * Автоколлект
   */
  "DeviceConfigurationStatus.Payload.Autocollect": {
    "kind": "class",
    "text": "Автоколлект",
    "fields": {
      /**
       * Дата включения автосбора.
       * # Тип: DateTime
       */
      "enabledAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата включения автосбора.\n# Тип: DateTime",
      },
      /**
       * Дата отключения автосбора.
       * # Тип: DateTime
       */
      "toBeDisabledAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата отключения автосбора.\n# Тип: DateTime",
      },
    },
  },
  /**
   * Сгруппированный по устройству список конфигураций
   */
  "DeviceConfigurationStatusGrouped": {
    "kind": "class",
    "text": "Сгруппированный по устройству список конфигураций",
    "fields": {
      /**
       * Идентификатор устройства
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Список конфигураций
       */
      "statuses": {
        "type": "DeviceConfigurationStatus",
        "text": "Список конфигураций",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Фильтр конфигураций сгруппированных по устройству
   */
  "DeviceConfigurationStatusGroupedFilter": {
    "kind": "class",
    "text": "Фильтр конфигураций сгруппированных по устройству",
    "fields": {
      /**
       * По идентификаторам устройства
       */
      "deviceIds": {
        "type": "int32",
        "text": "По идентификаторам устройства",
      },
      /**
       * По типам конфигурации
       */
      "configurationTypes": {
        "type": "DeviceConfigurationStatus.ConfigurationType",
        "text": "По типам конфигурации",
      },
      /**
       * По статусам конфигурации настройки
       */
      "statusTypes": {
        "type": "DeviceConfigurationStatus.StatusType",
        "text": "По статусам конфигурации настройки",
      },
      /**
       * Флаг, указывающий на готовность настройки к конфигурированию.
       * Значение next_retry_at меньше текущей даты
       */
      "isReadyForRetry": {
        "type": "google.protobuf.BoolValue",
        "text": "Флаг, указывающий на готовность настройки к конфигурированию.\nЗначение next_retry_at меньше текущей даты",
      },
      /**
       * Пороговое значение количества попыток.
       * Возвращает записи, у которых retry_count меньше этого значения
       */
      "retryCountLessThen": {
        "type": "google.protobuf.Int32Value",
        "text": "Пороговое значение количества попыток.\nВозвращает записи, у которых retry_count меньше этого значения",
      },
    },
  },
  /**
   * Постраничный вывод конфигураций сгруппированных по устройству
   */
  "DeviceConfigurationStatusGroupedPaging": {
    "kind": "class",
    "text": "Постраничный вывод конфигураций сгруппированных по устройству",
    "fields": {
      /**
       * Тип значения сортировки.
       * Если значение не передано, то будет взято значение по умолчанию.
       * # По умолчанию: DEVICE_ID
       */
      "orderByType": {
        "type": "DeviceConfigurationStatusGroupedPaging.OrderByType",
        "text": "Тип значения сортировки.\nЕсли значение не передано, то будет взято значение по умолчанию.\n# По умолчанию: DEVICE_ID",
      },
      /**
       * Тип направления сортировки.
       * # По умолчанию: DESC
       */
      "directionType": {
        "type": "DeviceConfigurationStatusGroupedPaging.DirectionType",
        "text": "Тип направления сортировки.\n# По умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Если значение 0 (не передано), то будет взято значение по умолчанию.
       * # Диапазон: 0..1000.
       * # По умолчанию: 20
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nЕсли значение 0 (не передано), то будет взято значение по умолчанию.\n# Диапазон: 0..1000.\n# По умолчанию: 20",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 1000,
            "message": "Значение не входит в допустимый диапазон. Максимум: 1000"
          },
        }
      },
      /**
       * Сдвиг.
       * # Диапазон: 0..2147483647
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Фильтр устройств
   */
  "DeviceFilter": {
    "kind": "class",
    "text": "Фильтр устройств",
    "fields": {
      /**
       * По идентификаторам компании владельца
       */
      "ownerCompanyIds": {
        "type": "int32",
        "text": "По идентификаторам компании владельца",
      },
      /**
       * Поиск по тексту.
       * Если значение не передано то поиск по нему не производится.
       * # Диапазон: 3..64.
       * # Поиск производится по полям:
       * # - Наименование;
       * # - MAC-адрес;
       * # - Список тегов устройства;
       * # - Сетевой адрес;
       * # - Серийный номер
       */
      "text": {
        "type": "google.protobuf.StringValue",
        "text": "Поиск по тексту.\nЕсли значение не передано то поиск по нему не производится.\n# Диапазон: 3..64.\n# Поиск производится по полям:\n# - Наименование;\n# - MAC-адрес;\n# - Список тегов устройства;\n# - Сетевой адрес;\n# - Серийный номер",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 64,
            "message": "Значение не входит в допустимый диапазон. Максимум: 64"
          },
        }
      },
      /**
       * Идентификатор квартирограммы
       */
      "flatgrammIds": {
        "type": "int32",
        "text": "Идентификатор квартирограммы",
      },
      /**
       * Серийный номер
       */
      "serialNumbers": {
        "type": "string",
        "text": "Серийный номер",
      },
      /**
       * Статус устройства
       */
      "deviceStatusTypes": {
        "type": "Device.StatusType",
        "text": "Статус устройства",
      },
      /**
       * Тип назначения устройства
       */
      "deviceTypes": {
        "type": "Device.Type",
        "text": "Тип назначения устройства",
      },
      /**
       * Модель устройства
       */
      "deviceModelTypes": {
        "type": "Device.ModelType",
        "text": "Модель устройства",
      },
      /**
       * Переадресация на консъержа
       */
      "isConciergeEnabled": {
        "type": "google.protobuf.BoolValue",
        "text": "Переадресация на консъержа",
      },
      /**
       * Диспетчеризация
       */
      "isDispatchingEnabled": {
        "type": "google.protobuf.BoolValue",
        "text": "Диспетчеризация",
      },
      /**
       * Поиск по публичному номеру диспетчеризации.
       * Если значение не передано то поиск по нему не производится.
       * # Диапазон: 3..64
       */
      "dispatchingPublicNumber": {
        "type": "google.protobuf.StringValue",
        "text": "Поиск по публичному номеру диспетчеризации.\nЕсли значение не передано то поиск по нему не производится.\n# Диапазон: 3..64",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 64,
            "message": "Значение не входит в допустимый диапазон. Максимум: 64"
          },
        }
      },
      /**
       * Версия аппаратного обеспенения.
       * # Диапазон: 3..64
       */
      "hardwareVersion": {
        "type": "google.protobuf.StringValue",
        "text": "Версия аппаратного обеспенения.\n# Диапазон: 3..64",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 64,
            "message": "Значение не входит в допустимый диапазон. Максимум: 64"
          },
        }
      },
      /**
       * Версия программного обеспенения.
       * # Диапазон: 3..64
       */
      "softwareVersion": {
        "type": "google.protobuf.StringValue",
        "text": "Версия программного обеспенения.\n# Диапазон: 3..64",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 64,
            "message": "Значение не входит в допустимый диапазон. Максимум: 64"
          },
        }
      },
      /**
       * Автозамена пароля
       */
      "isAutochangePasswordEnabled": {
        "type": "google.protobuf.BoolValue",
        "text": "Автозамена пароля",
      },
      /**
       * ABC-номер
       */
      "abcNumber": {
        "type": "string",
        "text": "ABC-номер",
      },
      /**
       * Идентификаторы камер
       */
      "cameraIds": {
        "type": "string",
        "text": "Идентификаторы камер",
      },
      /**
       * Фильтр по статусу синхронизации (SyncStatus.status_type)
       */
      "syncStatusStatusTypes": {
        "type": "SyncStatus.StatusType",
        "text": "Фильтр по статусу синхронизации (SyncStatus.status_type)",
      },
      /**
       * Пороговое значение количества попыток синхронизации.
       * Возвращает записи, у которых sync_retry_count меньше этого значения
       */
      "syncRetryCountLessThen": {
        "type": "google.protobuf.Int32Value",
        "text": "Пороговое значение количества попыток синхронизации.\nВозвращает записи, у которых sync_retry_count меньше этого значения",
      },
      /**
       * От даты успешной синхронизации включительно (>=)
       */
      "beginSyncSuccessfulAt": {
        "type": "google.protobuf.Timestamp",
        "text": "От даты успешной синхронизации включительно (>=)",
      },
      /**
       * До даты успешной синхронизации (<)
       */
      "endSyncSuccessfulAt": {
        "type": "google.protobuf.Timestamp",
        "text": "До даты успешной синхронизации (<)",
      },
      /**
       * От даты синхронизации включительно (>=)
       */
      "beginSyncAt": {
        "type": "google.protobuf.Timestamp",
        "text": "От даты синхронизации включительно (>=)",
      },
      /**
       * До даты синхронизации (<)
       */
      "endSyncAt": {
        "type": "google.protobuf.Timestamp",
        "text": "До даты синхронизации (<)",
      },
    },
  },
  /**
   * Облегчённое устройство.
   * # Описание модели
   */
  "DeviceLite": {
    "kind": "class",
    "text": "Облегчённое устройство.\n# Описание модели",
    "fields": {
      /**
       * Идентификатор.
       * # Диапазон: 0..2147483647
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
      /**
       * Тип назначения устройства
       */
      "type": {
        "type": "Device.Type",
        "text": "Тип назначения устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * # Диапазон: 3..256
       */
      "title": {
        "type": "string",
        "text": "# Диапазон: 3..256",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
      /**
       * Координаты
       */
      "location": {
        "type": "Device.Location",
        "text": "Координаты",
      },
      /**
       * Статус устройства
       */
      "statusType": {
        "type": "Device.StatusType",
        "text": "Статус устройства",
      },
    },
  },
  /**
   * Постраничный вывод
   */
  "DevicePaging": {
    "kind": "class",
    "text": "Постраничный вывод",
    "fields": {
      /**
       * Тип значения сортировки.
       * Если значение не передано, то будет взято значение по умолчанию.
       * # По умолчанию: ID
       */
      "orderByType": {
        "type": "DevicePaging.OrderByType",
        "text": "Тип значения сортировки.\nЕсли значение не передано, то будет взято значение по умолчанию.\n# По умолчанию: ID",
      },
      /**
       * Тип направления сортировки.
       * # По умолчанию: DESC
       */
      "directionType": {
        "type": "DevicePaging.DirectionType",
        "text": "Тип направления сортировки.\n# По умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Если значение 0 (не передано), то будет взято значение по умолчанию.
       * # Диапазон: 0..100.
       * # По умолчанию: 20
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nЕсли значение 0 (не передано), то будет взято значение по умолчанию.\n# Диапазон: 0..100.\n# По умолчанию: 20",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Сдвиг.
       * # Диапазон: 0..2147483647
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Запрос получения количества конфигураций сгруппированных по устройству
   */
  "GetDeviceConfigurationStatusGroupedCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества конфигураций сгруппированных по устройству",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "DeviceConfigurationStatusGroupedFilter",
        "text": "Фильтр",
      },
    },
  },
  /**
   * Ответ на запрос получения количества конфигураций сгруппированных по устройству
   */
  "GetDeviceConfigurationStatusGroupedCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества конфигураций сгруппированных по устройству",
    "fields": {
      /**
       * Количество
       */
      "data": {
        "type": "int32",
        "text": "Количество",
      },
    },
  },
  /**
   * Запрос получения списка конфигураций сгруппированных по устройству
   */
  "GetDeviceConfigurationStatusGroupedListRequest": {
    "kind": "class",
    "text": "Запрос получения списка конфигураций сгруппированных по устройству",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "DeviceConfigurationStatusGroupedFilter",
        "text": "Фильтр",
      },
      /**
       * Стандартный постраничный вывод
       */
      "paging": {
        "type": "DeviceConfigurationStatusGroupedPaging",
        "text": "Стандартный постраничный вывод",
      },
    },
  },
  /**
   * Ответ на запрос получения списка конфигураций сгруппированных по устройству
   */
  "GetDeviceConfigurationStatusGroupedListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка конфигураций сгруппированных по устройству",
    "fields": {
      /**
       * Конфигурации устройства
       */
      "data": {
        "type": "DeviceConfigurationStatusGrouped",
        "text": "Конфигурации устройства",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetDeviceConfigurationStatusGroupedListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка
   */
  "GetDeviceConfigurationStatusGroupedListResponse.Error": {
    "kind": "class",
    "text": "Ошибка",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения статусов конфигурации устройства
   */
  "GetDeviceConfigurationStatusesRequest": {
    "kind": "class",
    "text": "Запрос получения статусов конфигурации устройства",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения статусов конфигурации устройства
   */
  "GetDeviceConfigurationStatusesResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения статусов конфигурации устройства",
    "fields": {
      /**
       * Устройство
       */
      "data": {
        "type": "GetDeviceConfigurationStatusesResponse.Statuses",
        "text": "Устройство",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetDeviceConfigurationStatusesResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка
   */
  "GetDeviceConfigurationStatusesResponse.Error": {
    "kind": "class",
    "text": "Ошибка",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validationError": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Статусы
   */
  "GetDeviceConfigurationStatusesResponse.Statuses": {
    "kind": "class",
    "text": "Статусы",
    "fields": {
      /**
       * Статусы конфигурации устройства
       */
      "deviceConfigurationStatuses": {
        "type": "DeviceConfigurationStatus",
        "text": "Статусы конфигурации устройства",
      },
      /**
       * Статус камеры
       */
      "cameraStatus": {
        "type": "CameraStatus",
        "text": "Статус камеры",
      },
      /**
       * Статус синхронизации
       */
      "syncStatus": {
        "type": "SyncStatus",
        "text": "Статус синхронизации",
      },
      /**
       * Статус устройства
       */
      "deviceStatusType": {
        "type": "Device.StatusType",
        "text": "Статус устройства",
      },
    },
  },
  /**
   * Запрос получения количества устройств
   */
  "GetDeviceCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества устройств",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "DeviceFilter",
        "text": "Фильтр",
      },
    },
  },
  /**
   * Ответ на запрос получения количества устройств
   */
  "GetDeviceCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества устройств",
    "fields": {
      /**
       * Количество
       */
      "data": {
        "type": "int32",
        "text": "Количество",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetDeviceCountResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка
   */
  "GetDeviceCountResponse.Error": {
    "kind": "class",
    "text": "Ошибка",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения списка устройств
   */
  "GetDeviceListRequest": {
    "kind": "class",
    "text": "Запрос получения списка устройств",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "DeviceFilter",
        "text": "Фильтр",
      },
      /**
       * Пагинация
       */
      "paging": {
        "type": "DevicePaging",
        "text": "Пагинация",
      },
    },
  },
  /**
   * Ответ на запрос получения списка устройств
   */
  "GetDeviceListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка устройств",
    "fields": {
      /**
       * Устройство
       */
      "data": {
        "type": "Device",
        "text": "Устройство",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetDeviceListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса на получение списка устройств
   */
  "GetDeviceListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса на получение списка устройств",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения устройства
   */
  "GetDeviceLiteRequest": {
    "kind": "class",
    "text": "Запрос получения устройства",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения устройства
   */
  "GetDeviceLiteResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения устройства",
    "fields": {
      /**
       * Устройство
       */
      "data": {
        "type": "DeviceLite",
        "text": "Устройство",
      },
    },
  },
  /**
   * Запрос получения устройства
   */
  "GetDeviceRequest": {
    "kind": "class",
    "text": "Запрос получения устройства",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения устройства
   */
  "GetDeviceResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения устройства",
    "fields": {
      /**
       * Устройство
       */
      "data": {
        "type": "Device",
        "text": "Устройство",
      },
    },
  },
  /**
   * Запрос на изменение статуса конфигурации устройства
   */
  "PostDeviceConfigurationStatusRequest": {
    "kind": "class",
    "text": "Запрос на изменение статуса конфигурации устройства",
    "fields": {
      /**
       * Статус конфигурации устройства
       */
      "data": {
        "type": "DeviceConfigurationStatus",
        "text": "Статус конфигурации устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос на изменение статуса конфигурации устройства
   */
  "PostDeviceConfigurationStatusResponse": {
    "kind": "class",
    "text": "Ответ на запрос на изменение статуса конфигурации устройства",
    "fields": {
      /**
       * Статус конфигурации устройства
       */
      "data": {
        "type": "DeviceConfigurationStatus",
        "text": "Статус конфигурации устройства",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostDeviceConfigurationStatusResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса сохранения статуса конфигурации устройства
   */
  "PostDeviceConfigurationStatusResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса сохранения статуса конфигурации устройства",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос установки пресета на устройство
   */
  "PostDeviceInstallPresetRequest": {
    "kind": "class",
    "text": "Запрос установки пресета на устройство",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос установки пресета на устройство
   */
  "PostDeviceInstallPresetResponse": {
    "kind": "class",
    "text": "Ответ на запрос установки пресета на устройство",
    "fields": {
      /**
       * Ошибка при установке пресета
       */
      "error": {
        "type": "PostDeviceInstallPresetResponse.Error",
        "text": "Ошибка при установке пресета",
      },
    },
  },
  /**
   * Ошибка при установке пресета
   */
  "PostDeviceInstallPresetResponse.Error": {
    "kind": "class",
    "text": "Ошибка при установке пресета",
    "fields": {
      /**
       * Пресет в процессе установки
       */
      "presetStatusIsProcessing": {
        "type": "PostDeviceInstallPresetResponse.Error.PresetStatusIsProcessing",
        "text": "Пресет в процессе установки",
      },
    },
  },
  /**
   * Пресет в процессе установки
   */
  "PostDeviceInstallPresetResponse.Error.PresetStatusIsProcessing": {
    "kind": "class",
    "text": "Пресет в процессе установки",
  },
  /**
   * Запрос на переконфигурирование устройства
   */
  "PostDeviceReconfigureRequest": {
    "kind": "class",
    "text": "Запрос на переконфигурирование устройства",
    "fields": {
      /**
       * Идентификатор устройства
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос на переконфигурирование устройства
   */
  "PostDeviceReconfigureResponse": {
    "kind": "class",
    "text": "Ответ на запрос на переконфигурирование устройства",
    "fields": {
      /**
       * Ошибка переконфигурирования устройства
       */
      "error": {
        "type": "PostDeviceReconfigureResponse.Error",
        "text": "Ошибка переконфигурирования устройства",
      },
    },
  },
  /**
   * Ошибка переконфигурирования устройства
   */
  "PostDeviceReconfigureResponse.Error": {
    "kind": "class",
    "text": "Ошибка переконфигурирования устройства",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validationError": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Ошибка реинстала
       */
      "reinstallError": {
        "type": "ReinstallError",
        "text": "Ошибка реинстала",
      },
    },
  },
  /**
   * Запрос на замену устройства
   */
  "PostDeviceReplaceRequest": {
    "kind": "class",
    "text": "Запрос на замену устройства",
    "fields": {
      /**
       * Идентификатор устройства
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Хост
       */
      "host": {
        "type": "string",
        "text": "Хост",
      },
      /**
       * MAC-адрес.
       * # Диапазон: 17..17.
       * # Паттерн: /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/
       */
      "macAddress": {
        "type": "string",
        "text": "MAC-адрес.\n# Диапазон: 17..17.\n# Паттерн: /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 17,
            "message": "Значение не входит в допустимый диапазон. Минимум: 17"
          },
          "maxLength": {
            "value": 17,
            "message": "Значение не входит в допустимый диапазон. Максимум: 17"
          },
          "pattern": {
            "value": /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/,
            "message": "Значение не соответствует регулярному выражению. Паттерн: /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/"
          }
        }
      },
      /**
       * Серийный номер
       */
      "serialNumber": {
        "type": "string",
        "text": "Серийный номер",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Логин (для модели спутник)
       */
      "login": {
        "type": "string",
        "text": "Логин (для модели спутник)",
      },
    },
  },
  /**
   * Ответ на запрос на замену устройства
   */
  "PostDeviceReplaceResponse": {
    "kind": "class",
    "text": "Ответ на запрос на замену устройства",
    "fields": {
      /**
       * Ошибка замены устройства
       */
      "error": {
        "type": "PostDeviceReplaceResponse.Error",
        "text": "Ошибка замены устройства",
      },
    },
  },
  /**
   * Ошибка замены устройства
   */
  "PostDeviceReplaceResponse.Error": {
    "kind": "class",
    "text": "Ошибка замены устройства",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validationError": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * На платформе уже существует устройство с таким хостом
       */
      "hostExists": {
        "type": "PostDeviceReplaceResponse.Error.HostExists",
        "text": "На платформе уже существует устройство с таким хостом",
      },
      /**
       * На платформе уже существует устройство с таким MAC-адресом
       */
      "macAddressExists": {
        "type": "PostDeviceReplaceResponse.Error.MacAddressExists",
        "text": "На платформе уже существует устройство с таким MAC-адресом",
      },
      /**
       * На платформе уже существует устройство с таким серийным номером
       */
      "serialNumberExists": {
        "type": "PostDeviceReplaceResponse.Error.SerialNumberExists",
        "text": "На платформе уже существует устройство с таким серийным номером",
      },
      /**
       * На платформе уже существует устройство с таким логином (для устройст модели \"Спутник\")
       */
      "loginExists": {
        "type": "PostDeviceReplaceResponse.Error.LoginExists",
        "text": "На платформе уже существует устройство с таким логином (для устройст модели \"Спутник\")",
      },
      /**
       * Отсутствует поле Login для модели \"Спутник\"
       */
      "loginIsRequired": {
        "type": "PostDeviceReplaceResponse.Error.LoginIsRequired",
        "text": "Отсутствует поле Login для модели \"Спутник\"",
      },
      /**
       * Ошибка реинстала
       */
      "reinstallError": {
        "type": "ReinstallError",
        "text": "Ошибка реинстала",
      },
    },
  },
  /**
   * На платформе уже существует устройство с таким хостом
   */
  "PostDeviceReplaceResponse.Error.HostExists": {
    "kind": "class",
    "text": "На платформе уже существует устройство с таким хостом",
  },
  /**
   * На платформе уже существует устройство с таким логином (для устройст модели \"Спутник\")
   */
  "PostDeviceReplaceResponse.Error.LoginExists": {
    "kind": "class",
    "text": "На платформе уже существует устройство с таким логином (для устройст модели \"Спутник\")",
  },
  /**
   * Отсутствует поле Login для модели \"Спутник\"
   */
  "PostDeviceReplaceResponse.Error.LoginIsRequired": {
    "kind": "class",
    "text": "Отсутствует поле Login для модели \"Спутник\"",
  },
  /**
   * На платформе уже существует устройство с таким MAC-адресом
   */
  "PostDeviceReplaceResponse.Error.MacAddressExists": {
    "kind": "class",
    "text": "На платформе уже существует устройство с таким MAC-адресом",
  },
  /**
   * На платформе уже существует устройство с таким серийным номером
   */
  "PostDeviceReplaceResponse.Error.SerialNumberExists": {
    "kind": "class",
    "text": "На платформе уже существует устройство с таким серийным номером",
  },
  /**
   * Запрос на создание/изменение устройства
   */
  "PostDeviceRequest": {
    "kind": "class",
    "text": "Запрос на создание/изменение устройства",
    "fields": {
      /**
       * Устройство
       */
      "data": {
        "type": "Device",
        "text": "Устройство",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос на создание/изменение устройства
   */
  "PostDeviceResponse": {
    "kind": "class",
    "text": "Ответ на запрос на создание/изменение устройства",
    "fields": {
      /**
       * Устройство
       */
      "data": {
        "type": "Device",
        "text": "Устройство",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostDeviceResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса сохранения устройства
   */
  "PostDeviceResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса сохранения устройства",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Ошибка сохранения
       */
      "saving": {
        "type": "Device.SavingError",
        "text": "Ошибка сохранения",
      },
    },
  },
  /**
   * Пресет.
   * Пресет с id=1 устанавливается при создании устройства по умолчанию
   */
  "Preset": {
    "kind": "class",
    "text": "Пресет.\nПресет с id=1 устанавливается при создании устройства по умолчанию",
    "fields": {
      /**
       * Идентификатор.
       * # Диапазон: 1..2147483647
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор.\n# Диапазон: 1..2147483647",
        "rules": {
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
      /**
       * Наименование.
       * # Диапазон: 3..256
       */
      "title": {
        "type": "string",
        "text": "Наименование.\n# Диапазон: 3..256",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
      /**
       * Идентификатор МРФ.
       * # Диапазон: 0..10
       */
      "mrfIds": {
        "type": "int32",
        "text": "Идентификатор МРФ.\n# Диапазон: 0..10",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 10,
            "message": "Значение не входит в допустимый диапазон. Максимум: 10"
          },
        }
      },
      /**
       * Идентификатор РФ.
       * # Диапазон: 0..100
       */
      "rfIds": {
        "type": "int32",
        "text": "Идентификатор РФ.\n# Диапазон: 0..100",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Описание.
       * # Диапазон: 3..1024
       */
      "description": {
        "type": "google.protobuf.StringValue",
        "text": "Описание.\n# Диапазон: 3..1024",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 1024,
            "message": "Значение не входит в допустимый диапазон. Максимум: 1024"
          },
        }
      },
      /**
       * Дата и время создания.
       * # Тип: DateTime
       */
      "createdAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата и время создания.\n# Тип: DateTime",
      },
      /**
       * Дата последнего изменения.
       * Заполняется и обновляется сервером.
       * Заполняется при создании и изменении.
       * Является версией объекта.
       * # Тип: DateTime
       */
      "changedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата последнего изменения.\nЗаполняется и обновляется сервером.\nЗаполняется при создании и изменении.\nЯвляется версией объекта.\n# Тип: DateTime",
      },
      /**
       * Статус
       */
      "statusType": {
        "type": "Preset.StatusType",
        "text": "Статус",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Параметр SIP
       */
      "sip": {
        "type": "Preset.Sip",
        "text": "Параметр SIP",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Параметр NTP
       */
      "ntp": {
        "type": "Preset.Ntp",
        "text": "Параметр NTP",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Параметр Syslog
       */
      "syslog": {
        "type": "Preset.Syslog",
        "text": "Параметр Syslog",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Помещения.
       * # Диапазон: 0..10000
       */
      "rooms": {
        "type": "Preset.Room",
        "text": "Помещения.\n# Диапазон: 0..10000",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 10000,
            "message": "Значение не входит в допустимый диапазон. Максимум: 10000"
          },
        }
      },
      /**
       * Параметры конфигурации видео
       */
      "videoConfig": {
        "type": "Preset.VideoConfig",
        "text": "Параметры конфигурации видео",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Параметр DTMF.
       * # Диапазон: 0..64
       */
      "dtmf": {
        "type": "Preset.Dtmf",
        "text": "Параметр DTMF.\n# Диапазон: 0..64",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 64,
            "message": "Значение не входит в допустимый диапазон. Максимум: 64"
          },
        }
      },
      /**
       * Распознование лиц
       */
      "faceRecognition": {
        "type": "Preset.FaceRecognition",
        "text": "Распознование лиц",
      },
    },
  },
  /**
   * Параметр DTMF
   */
  "Preset.Dtmf": {
    "kind": "class",
    "text": "Параметр DTMF",
    "fields": {
      /**
       * Код.
       * # Диапазон: 1..1
       */
      "code": {
        "type": "string",
        "text": "Код.\n# Диапазон: 1..1",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "maxLength": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Максимум: 1"
          },
        }
      },
      /**
       * Индекс реле.
       * # Диапазон: 0..64
       */
      "relayIndex": {
        "type": "int32",
        "text": "Индекс реле.\n# Диапазон: 0..64",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 64,
            "message": "Значение не входит в допустимый диапазон. Максимум: 64"
          },
        }
      },
    },
  },
  /**
   * Распознование лиц
   */
  "Preset.FaceRecognition": {
    "kind": "class",
    "text": "Распознование лиц",
    "fields": {
      /**
       * Адрес
       */
      "host": {
        "type": "string",
        "text": "Адрес",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Альтернативный адрес
       */
      "altHost": {
        "type": "string",
        "text": "Альтернативный адрес",
      },
      /**
       * Путь запроса к серверу
       */
      "endpoint": {
        "type": "string",
        "text": "Путь запроса к серверу",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Токен
       */
      "authToken": {
        "type": "string",
        "text": "Токен",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип конфигурации
       */
      "configurationType": {
        "type": "Preset.FaceRecognition.ConfigurationType",
        "text": "Тип конфигурации",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор источника в identix
       */
      "originId": {
        "type": "string",
        "text": "Идентификатор источника в identix",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификаторы групп профилей в identix
       */
      "groupIds": {
        "type": "int32",
        "text": "Идентификаторы групп профилей в identix",
      },
    },
  },
  /**
   * Параметр NTP
   */
  "Preset.Ntp": {
    "kind": "class",
    "text": "Параметр NTP",
    "fields": {
      /**
       * Хост.
       * # Диапазон: 5..256
       */
      "host": {
        "type": "string",
        "text": "Хост.\n# Диапазон: 5..256",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 5,
            "message": "Значение не входит в допустимый диапазон. Минимум: 5"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
      /**
       * Порт.
       * # Диапазон: 1..65536
       */
      "port": {
        "type": "int32",
        "text": "Порт.\n# Диапазон: 1..65536",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 65536,
            "message": "Значение не входит в допустимый диапазон. Максимум: 65536"
          },
        }
      },
    },
  },
  /**
   * Помещение
   */
  "Preset.Room": {
    "kind": "class",
    "text": "Помещение",
    "fields": {
      /**
       * Номер телефона.
       * # Диапазон: 5..14
       */
      "phone": {
        "type": "string",
        "text": "Номер телефона.\n# Диапазон: 5..14",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 5,
            "message": "Значение не входит в допустимый диапазон. Минимум: 5"
          },
          "maxLength": {
            "value": 14,
            "message": "Значение не входит в допустимый диапазон. Максимум: 14"
          },
        }
      },
      /**
       * Номер помещения.
       * # Диапазон: 1..10000
       */
      "num": {
        "type": "int32",
        "text": "Номер помещения.\n# Диапазон: 1..10000",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 10000,
            "message": "Значение не входит в допустимый диапазон. Максимум: 10000"
          },
        }
      },
    },
  },
  /**
   * Ошибка сохранения.
   * Эти проверки выполняются при работе с базой данных и сторонними сервисами
   */
  "Preset.SavingError": {
    "kind": "class",
    "text": "Ошибка сохранения.\nЭти проверки выполняются при работе с базой данных и сторонними сервисами",
    "fields": {
      /**
       * Конфликт версий
       */
      "conflict": {
        "type": "Preset.SavingError.Conflict",
        "text": "Конфликт версий",
      },
      /**
       * Запрещено для дефолтного пресета
       */
      "notAllowedForDefault": {
        "type": "Preset.SavingError.NotAllowedForDefault",
        "text": "Запрещено для дефолтного пресета",
      },
    },
  },
  /**
   * Конфликт версий.
   * Причины:
   * - В базе хранится другая версия строки, значения changed_at отличаются
   */
  "Preset.SavingError.Conflict": {
    "kind": "class",
    "text": "Конфликт версий.\nПричины:\n- В базе хранится другая версия строки, значения changed_at отличаются",
  },
  /**
   * Недоступно для дефолтного пресета.
   * Причины:
   * - Смена статуса на Архивный
   */
  "Preset.SavingError.NotAllowedForDefault": {
    "kind": "class",
    "text": "Недоступно для дефолтного пресета.\nПричины:\n- Смена статуса на Архивный",
  },
  /**
   * Параметр SIP
   */
  "Preset.Sip": {
    "kind": "class",
    "text": "Параметр SIP",
    "fields": {
      /**
       * Хост.
       * # Диапазон: 5..256
       */
      "host": {
        "type": "string",
        "text": "Хост.\n# Диапазон: 5..256",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 5,
            "message": "Значение не входит в допустимый диапазон. Минимум: 5"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
      /**
       * Порт.
       * # Диапазон: 1..65536
       */
      "port": {
        "type": "int32",
        "text": "Порт.\n# Диапазон: 1..65536",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 65536,
            "message": "Значение не входит в допустимый диапазон. Максимум: 65536"
          },
        }
      },
      /**
       * Хост reg.
       * # Диапазон: 5..256
       */
      "regHost": {
        "type": "string",
        "text": "Хост reg.\n# Диапазон: 5..256",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 5,
            "message": "Значение не входит в допустимый диапазон. Минимум: 5"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
      /**
       * Порт reg.
       * # Диапазон: 1..65536
       */
      "regPort": {
        "type": "int32",
        "text": "Порт reg.\n# Диапазон: 1..65536",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 65536,
            "message": "Значение не входит в допустимый диапазон. Максимум: 65536"
          },
        }
      },
      /**
       * Хост proxy.
       * # Диапазон: 5..256
       */
      "proxyHost": {
        "type": "string",
        "text": "Хост proxy.\n# Диапазон: 5..256",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 5,
            "message": "Значение не входит в допустимый диапазон. Минимум: 5"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
      /**
       * Порт proxy.
       * # Диапазон: 1..65536
       */
      "proxyPort": {
        "type": "int32",
        "text": "Порт proxy.\n# Диапазон: 1..65536",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 65536,
            "message": "Значение не входит в допустимый диапазон. Максимум: 65536"
          },
        }
      },
    },
  },
  /**
   * Параметр Syslog
   */
  "Preset.Syslog": {
    "kind": "class",
    "text": "Параметр Syslog",
    "fields": {
      /**
       * Хост.
       * # Диапазон: 5..256
       */
      "host": {
        "type": "string",
        "text": "Хост.\n# Диапазон: 5..256",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 5,
            "message": "Значение не входит в допустимый диапазон. Минимум: 5"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
      /**
       * Порт.
       * # Диапазон: 1..65536
       */
      "port": {
        "type": "int32",
        "text": "Порт.\n# Диапазон: 1..65536",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 65536,
            "message": "Значение не входит в допустимый диапазон. Максимум: 65536"
          },
        }
      },
      /**
       * Протокол
       */
      "protocolType": {
        "type": "Preset.Syslog.ProtocolType",
        "text": "Протокол",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Параметры конфигурации видео
   */
  "Preset.VideoConfig": {
    "kind": "class",
    "text": "Параметры конфигурации видео",
    "fields": {
      /**
       * Тип пресета
       */
      "qualityType": {
        "type": "Preset.VideoConfig.QualityType",
        "text": "Тип пресета",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Пользователь
       */
      "rtspUser": {
        "type": "Preset.VideoConfig.RtspUser",
        "text": "Пользователь",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Пользователь
   */
  "Preset.VideoConfig.RtspUser": {
    "kind": "class",
    "text": "Пользователь",
    "fields": {
      /**
       * Имя пользователя.
       * # Диапазон: 3..256
       */
      "username": {
        "type": "string",
        "text": "Имя пользователя.\n# Диапазон: 3..256",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
      /**
       * Пароль.
       * # Диапазон: 3..256
       */
      "password": {
        "type": "string",
        "text": "Пароль.\n# Диапазон: 3..256",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
    },
  },
  /**
   * Запрос изменения устройства
   */
  "PutDeviceRequest": {
    "kind": "class",
    "text": "Запрос изменения устройства",
    "fields": {
      /**
       * Идентификатор устройства
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор пресета
       */
      "presetId": {
        "type": "int32",
        "text": "Идентификатор пресета",
      },
      /**
       * Настройка режима SL3
       */
      "isSl3ModeEnabled": {
        "type": "bool",
        "text": "Настройка режима SL3",
      },
    },
  },
  /**
   * ответ на завпрос изменения устройства
   */
  "PutDeviceResponse": {
    "kind": "class",
    "text": "ответ на завпрос изменения устройства",
    "fields": {
      /**
       * Устройство
       */
      "data": {
        "type": "Device",
        "text": "Устройство",
      },
    },
  },
  /**
   * Ошибки реинстала
   */
  "ReinstallError": {
    "kind": "class",
    "text": "Ошибки реинстала",
    "fields": {
      /**
       * Сип-логин отсутствует на устройстве
       */
      "sipLoginIsMissing": {
        "type": "ReinstallError.SipLoginIsMissing",
        "text": "Сип-логин отсутствует на устройстве",
      },
    },
  },
  /**
   * Сип-логин отсутствует на устройстве
   */
  "ReinstallError.SipLoginIsMissing": {
    "kind": "class",
    "text": "Сип-логин отсутствует на устройстве",
  },
  /**
   * Статус синхронизации.
   * # Описание модели
   */
  "SyncStatus": {
    "kind": "class",
    "text": "Статус синхронизации.\n# Описание модели",
    "fields": {
      /**
       * Статус синхронизации
       */
      "statusType": {
        "type": "SyncStatus.StatusType",
        "text": "Статус синхронизации",
      },
      /**
       * Сообщение об ошибке
       */
      "errorMessage": {
        "type": "string",
        "text": "Сообщение об ошибке",
      },
      /**
       * Количество попыток
       */
      "retryCount": {
        "type": "int32",
        "text": "Количество попыток",
      },
      /**
       * Дата последней успешной синхронизации.
       * # Тип: DateTime
       */
      "successfulAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата последней успешной синхронизации.\n# Тип: DateTime",
      },
      /**
       * Дата последней синхронизации.
       * # Тип: DateTime
       */
      "syncAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата последней синхронизации.\n# Тип: DateTime",
      },
    },
  },
  /**
   * Ошибки валидации.
   * Эти проверки выполняются до обращения в базу данных
   */
  "ValidationError": {
    "kind": "class",
    "text": "Ошибки валидации.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Путь к полю в формате наименования прото
       */
      "path": {
        "type": "string",
        "text": "Путь к полю в формате наименования прото",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Валидационное сообщение
       */
      "message": {
        "type": "string",
        "text": "Валидационное сообщение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Статус камеры.
   */
  "CameraStatus.StatusType": {
    "kind": "enum",
    "text": "Статус камеры.",
    "values": {
      /**
       * Значение не указано
       */
      "STATUS_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * В процессе регистрации
       */
      "PROCESSING": {
        "i": 1,
        "text": "В процессе регистрации",
      },
      /**
       * Ошибка регистрации
       */
      "PROCESSING_ERROR": {
        "i": 2,
        "text": "Ошибка регистрации",
      },
      /**
       * Активна
       */
      "ACTIVE": {
        "i": 3,
        "text": "Активна",
      },
    },
  },
  /**
   * Тип доступа пользователя.
   */
  "Device.Credentials.UserAccessType": {
    "kind": "enum",
    "text": "Тип доступа пользователя.",
    "values": {
      /**
       * Значение не указано
       */
      "USER_ACCESS_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Доступ к api
       */
      "API": {
        "i": 1,
        "text": "Доступ к api",
      },
      /**
       * Доступ к web-интерфейсу
       */
      "WEB": {
        "i": 2,
        "text": "Доступ к web-интерфейсу",
      },
      /**
       * Доступ к rtsp-потоку
       */
      "RTSP": {
        "i": 3,
        "text": "Доступ к rtsp-потоку",
      },
      /**
       * Полный доступ
       */
      "SU": {
        "i": 4,
        "text": "Полный доступ",
      },
    },
  },
  /**
   * Модель устройства.
   */
  "Device.ModelType": {
    "kind": "enum",
    "text": "Модель устройства.",
    "values": {
      /**
       * Значение не указано
       */
      "MODEL_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Модель RODOS-8
       */
      "RODOS8": {
        "i": 1,
        "text": "Модель RODOS-8",
      },
      /**
       * Модель Beward
       */
      "BEWARD": {
        "i": 2,
        "text": "Модель Beward",
      },
      /**
       * Модель QTECH
       */
      "QTECH": {
        "i": 3,
        "text": "Модель QTECH",
      },
      /**
       * Модель Натекс
       */
      "NATEKS": {
        "i": 4,
        "text": "Модель Натекс",
      },
      /**
       * Модель ТНБ
       */
      "TNB": {
        "i": 5,
        "text": "Модель ТНБ",
      },
      /**
       * Модель Maxet Line
       */
      "MAXETLINE": {
        "i": 6,
        "text": "Модель Maxet Line",
      },
      /**
       * Модель Двойная открывашка
       */
      "TNB_DO2": {
        "i": 7,
        "text": "Модель Двойная открывашка",
      },
      /**
       * Модель Beward DS86017CP
       */
      "BEWARD_DS86017CP": {
        "i": 8,
        "text": "Модель Beward DS86017CP",
      },
      /**
       * Модель Beward DS85006MP
       */
      "BEWARD_DS85006MP": {
        "i": 9,
        "text": "Модель Beward DS85006MP",
      },
      /**
       * Модель Dahua DHI-VTO2101E-P
       */
      "DAHUA_VTO2101E_P": {
        "i": 10,
        "text": "Модель Dahua DHI-VTO2101E-P",
      },
      /**
       * Модель Hikvision DS-KV8155-IM
       */
      "HIKVISION_DS_KV8155_IM": {
        "i": 11,
        "text": "Модель Hikvision DS-KV8155-IM",
      },
      /**
       * Модель RODOS-8-2
       */
      "RODOS8_2": {
        "i": 12,
        "text": "Модель RODOS-8-2",
      },
      /**
       * Модель Akuvox R29C
       */
      "AKUVOX_R29C": {
        "i": 13,
        "text": "Модель Akuvox R29C",
      },
      /**
       * Модель Safe-logic
       */
      "SAFE_LOGIC": {
        "i": 14,
        "text": "Модель Safe-logic",
      },
      /**
       * Модель Beward DS86006AP
       */
      "BEWARD_DS86006AP": {
        "i": 15,
        "text": "Модель Beward DS86006AP",
      },
      /**
       * Модель Спутник Ио
       */
      "SPUTNIK_IO": {
        "i": 16,
        "text": "Модель Спутник Ио",
      },
      /**
       * Модель Beward c FR
       */
      "BEWARD_FR": {
        "i": 17,
        "text": "Модель Beward c FR",
      },
      /**
       * Модель QTECH с FR
       */
      "QTECH_FR": {
        "i": 18,
        "text": "Модель QTECH с FR",
      },
      /**
       * Модель Eltex IPA-ER-10
       */
      "ELTEX_IPA_ER_010": {
        "i": 19,
        "text": "Модель Eltex IPA-ER-10",
      },
      /**
       * Модель Beward с новым API ключей
       */
      "BEWARD_MIFARE": {
        "i": 20,
        "text": "Модель Beward с новым API ключей",
      },
      /**
       * Модель BAS-IP AA-12FB
       */
      "BAS_IP_AA_12FB": {
        "i": 21,
        "text": "Модель BAS-IP AA-12FB",
      },
      /**
       * Модель Akuvox X915S
       */
      "AKUVOX_X915S": {
        "i": 22,
        "text": "Модель Akuvox X915S",
      },
      /**
       * Модель Rubetek RV-3434
       */
      "RUBETEK_RV_3434": {
        "i": 23,
        "text": "Модель Rubetek RV-3434",
      },
      /**
       * Модель Сокол плюс
       */
      "SOKOL_PLUS": {
        "i": 24,
        "text": "Модель Сокол плюс",
      },
      /**
       * Модель Beward Эконом
       */
      "BEWARD_LOW_COST": {
        "i": 25,
        "text": "Модель Beward Эконом",
      },
    },
  },
  /**
   * Справочник статусов установки пресета.
   * @deprecated
   */
  "Device.PresetStatusType": {
    "kind": "enum",
    "text": "Справочник статусов установки пресета.",
    "values": {
      /**
       * Значение не указано
       * @deprecated
       */
      "PRESET_STATUS_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
        "options": {"deprecated":true},
      },
      /**
       * Устанавливается
       * @deprecated
       */
      "PROCESSING": {
        "i": 1,
        "text": "Устанавливается",
        "options": {"deprecated":true},
      },
      /**
       * Установлен
       * @deprecated
       */
      "SUCCESS": {
        "i": 2,
        "text": "Установлен",
        "options": {"deprecated":true},
      },
      /**
       * Ошибка
       * @deprecated
       */
      "ERROR": {
        "i": 3,
        "text": "Ошибка",
        "options": {"deprecated":true},
      },
    },
  },
  /**
   * Тип сети связи.
   */
  "Device.SipTrunk.SipType": {
    "kind": "enum",
    "text": "Тип сети связи.",
    "values": {
      /**
       * Значение не указано
       */
      "SIP_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Тип Viprtual IP Multimedia Subsystem
       */
      "VIMS": {
        "i": 1,
        "text": "Тип Viprtual IP Multimedia Subsystem",
      },
      /**
       * Тип Next Generation Networks
       */
      "NGN": {
        "i": 2,
        "text": "Тип Next Generation Networks",
      },
    },
  },
  /**
   * Справочник статусов устройства.
   */
  "Device.StatusType": {
    "kind": "enum",
    "text": "Справочник статусов устройства.",
    "values": {
      /**
       * Значение не указано
       */
      "STATUS_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Не в сети
       */
      "OFFLINE": {
        "i": 1,
        "text": "Не в сети",
      },
      /**
       * В сети
       */
      "ONLINE": {
        "i": 2,
        "text": "В сети",
      },
    },
  },
  /**
   * Справочник назначений типов устройств (в качестве чего выступает устройство).
   */
  "Device.Type": {
    "kind": "enum",
    "text": "Справочник назначений типов устройств (в качестве чего выступает устройство).",
    "values": {
      /**
       * Значение не указано
       */
      "TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Домофон
       */
      "INTERCOM": {
        "i": 1,
        "text": "Домофон",
      },
      /**
       * Видеокамера
       * @deprecated
       */
      "VIDEOCAMERA": {
        "i": 2,
        "text": "Видеокамера",
        "options": {"deprecated":true},
      },
      /**
       * Шлагбаум
       */
      "BARRIER": {
        "i": 3,
        "text": "Шлагбаум",
      },
      /**
       * Калитка
       */
      "GATE": {
        "i": 4,
        "text": "Калитка",
      },
      /**
       * СКУД
       * @deprecated
       */
      "ACCESS_CONTROL_PANEL": {
        "i": 5,
        "text": "СКУД",
        "options": {"deprecated":true},
      },
      /**
       * Наружняя видеокамера
       * @deprecated
       */
      "OUTDOOR_CAMERA": {
        "i": 6,
        "text": "Наружняя видеокамера",
        "options": {"deprecated":true},
      },
    },
  },
  /**
   * Тип конфигурации.
   */
  "DeviceConfigurationStatus.ConfigurationType": {
    "kind": "enum",
    "text": "Тип конфигурации.",
    "values": {
      /**
       * Значение не указано
       */
      "CONFIGURATION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Пресет
       */
      "PRESET": {
        "i": 1,
        "text": "Пресет",
      },
      /**
       * Сип-аккаунт
       */
      "SIP_ACCOUNT": {
        "i": 2,
        "text": "Сип-аккаунт",
      },
      /**
       * сип-номера в помещениях
       */
      "SIP_ROOMS": {
        "i": 3,
        "text": "сип-номера в помещениях",
      },
      /**
       * Калитка
       */
      "GATE": {
        "i": 4,
        "text": "Калитка",
      },
      /**
       * Ключи
       */
      "RFIDS": {
        "i": 5,
        "text": "Ключи",
      },
      /**
       * Коды
       */
      "CODES": {
        "i": 6,
        "text": "Коды",
      },
      /**
       * Распознование лиц
       */
      "FACE_RECOGNITION": {
        "i": 7,
        "text": "Распознование лиц",
      },
      /**
       * Консьерж
       */
      "CONCIERGE": {
        "i": 8,
        "text": "Консьерж",
      },
      /**
       * Автосбор
       */
      "AUTOCOLLECT": {
        "i": 9,
        "text": "Автосбор",
      },
      /**
       * Режим Sl3
       */
      "SL3": {
        "i": 10,
        "text": "Режим Sl3",
      },
      /**
       * Вызов экстренной службы
       */
      "EMERGENCY_CALL": {
        "i": 11,
        "text": "Вызов экстренной службы",
      },
    },
  },
  /**
   * Справочник статусов конфигурации настройки устройства.
   */
  "DeviceConfigurationStatus.StatusType": {
    "kind": "enum",
    "text": "Справочник статусов конфигурации настройки устройства.",
    "values": {
      /**
       * Значение не указано
       */
      "STATUS_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Настроен
       */
      "SUCCESS": {
        "i": 1,
        "text": "Настроен",
      },
      /**
       * Ошибка
       */
      "ERROR": {
        "i": 2,
        "text": "Ошибка",
      },
      /**
       * В ожидании обработки
       */
      "PENDING": {
        "i": 3,
        "text": "В ожидании обработки",
      },
      /**
       * В процессе обработки
       */
      "PROCESSING": {
        "i": 4,
        "text": "В процессе обработки",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки.
   */
  "DeviceConfigurationStatusGroupedPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки.
   */
  "DeviceConfigurationStatusGroupedPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По идентификатору устройства
       */
      "DEVICE_ID": {
        "i": 1,
        "text": "По идентификатору устройства",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки.
   */
  "DevicePaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки.
   */
  "DevicePaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По идентификатору
       */
      "ID": {
        "i": 1,
        "text": "По идентификатору",
      },
      /**
       * По наименованию
       */
      "TITLE": {
        "i": 2,
        "text": "По наименованию",
      },
      /**
       * По дате последней попытки синхронизации
       */
      "SYNC_AT": {
        "i": 3,
        "text": "По дате последней попытки синхронизации",
      },
    },
  },
  /**
   * Тип конфигурации.
   */
  "Preset.FaceRecognition.ConfigurationType": {
    "kind": "enum",
    "text": "Тип конфигурации.",
    "values": {
      /**
       * Значение не указано
       */
      "CONFIGURATION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По умолчанию
       */
      "DEFAULT": {
        "i": 1,
        "text": "По умолчанию",
      },
    },
  },
  /**
   * Справочник статусов.
   */
  "Preset.StatusType": {
    "kind": "enum",
    "text": "Справочник статусов.",
    "values": {
      /**
       * Значение не указано
       */
      "STATUS_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Активный
       */
      "ACTIVE": {
        "i": 1,
        "text": "Активный",
      },
      /**
       * Архивный
       */
      "ARCHIVE": {
        "i": 2,
        "text": "Архивный",
      },
    },
  },
  /**
   * Тип протокола.
   */
  "Preset.Syslog.ProtocolType": {
    "kind": "enum",
    "text": "Тип протокола.",
    "values": {
      /**
       * Значение не указано
       */
      "PROTOCOL_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Протокол UDP
       */
      "UDP": {
        "i": 1,
        "text": "Протокол UDP",
      },
      /**
       * Протокол TCP
       */
      "TCP": {
        "i": 2,
        "text": "Протокол TCP",
      },
    },
  },
  /**
   * Справочник качеств.
   */
  "Preset.VideoConfig.QualityType": {
    "kind": "enum",
    "text": "Справочник качеств.",
    "values": {
      /**
       * Значение не указано
       */
      "QUALITY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Высокое качество
       */
      "HIGH": {
        "i": 1,
        "text": "Высокое качество",
      },
      /**
       * Среднее качество
       */
      "MEDIUM": {
        "i": 2,
        "text": "Среднее качество",
      },
    },
  },
  /**
   * Статус синхронизации.
   */
  "SyncStatus.StatusType": {
    "kind": "enum",
    "text": "Статус синхронизации.",
    "values": {
      /**
       * Значение не указано
       */
      "STATUS_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Новый
       */
      "NEW": {
        "i": 1,
        "text": "Новый",
      },
      /**
       * В процессе
       */
      "PENDING": {
        "i": 2,
        "text": "В процессе",
      },
      /**
       * Ошибка
       */
      "ERROR": {
        "i": 3,
        "text": "Ошибка",
      },
      /**
       * Успешно
       */
      "SUCCESS": {
        "i": 4,
        "text": "Успешно",
      },
      /**
       * Выключено
       */
      "DISABLED": {
        "i": 5,
        "text": "Выключено",
      },
    },
  },
}